module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('pre'), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "pgepubid00000"
    }
  }, [_vm._v("OSCAR WILDE")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("This Edition consists of 500 copies.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Fifty copies have been printed on\nhand-made paper.")]), _vm._v(" "), _c('hr', {
    staticClass: "r35"
  }), _vm._v(" "), _c('div', {
    staticClass: "figcenter",
    staticStyle: {
      "width": "450px"
    },
    attrs: {
      "aria-labelledby": "ebm_caption0",
      "role": "figure"
    }
  }, [_c('a', {
    attrs: {
      "id": "HOW_UTTER"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "id": "id-8858327856636292757",
      "src": "5208151284131596110_ill01.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption",
    attrs: {
      "id": "ebm_caption0"
    }
  }, [_vm._v("'HOW UTTER.'")])]), _vm._v(" "), _c('hr', {
    staticClass: "chap"
  }), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("Oscar Wilde"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "60%"
    }
  }, [_vm._v("A STUDY")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("FROM THE FRENCH OF")]), _c('br'), _vm._v("\n\nANDRÉ GIDE")]), _vm._v(" "), _c('p', {
    staticClass: "edition"
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("WITH INTRODUCTION, NOTES AND BIBLIOGRAPHY"), _c('br'), _vm._v("\n\nBY")]), _c('br'), _vm._v("\n\nSTUART MASON")]), _vm._v(" "), _c('p', {
    staticClass: "editor"
  }, [_vm._v("Oxford"), _c('br'), _vm._v("\n\nTHE HOLYWELL PRESS"), _c('br'), _vm._v("\n\nMCMV")]), _vm._v(" "), _c('hr', {
    staticClass: "tb"
  }), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("To")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Donald Bruce Wallace,")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("of New York,")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("in Memory of a Visit last Summer to")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Bagneux Cemetery,")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("A Pilgrimage of Love when we")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("watered with our Tears the Roses and Lilies")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("with which we covered")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The Poet's Grave.\n")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Oxford,")]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("September, 1905.")]), _vm._v(" "), _c('hr', {
    staticClass: "chap"
  }), _vm._v(" "), _c('p', [_vm._v("[The little poem on the opposite page first saw the light in the\npages of the "), _c('i', [_vm._v("Dublin University Magazine")]), _vm._v(" for September,\n1876. It has not been reprinted since. The Greek quotation\nis taken from the "), _c('i', [_vm._v("Agamemnon")]), _vm._v(" of Æschylos, l. 120. ]")]), _vm._v(" "), _c('hr', {
    staticClass: "r5"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00001",
      "title": "[Pg xi]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_xi",
      "title": "[Pg xi]"
    }
  })])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "pgepubid00002"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("Αἴλινον, αἴινον εἰπὲ,"), _c('br'), _vm._v("\n\nΤὸ δ᾽ ευ̉ νικάτω")])]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('span', {
    staticClass: "i0"
  }, [_vm._v("O well for him who lives at ease"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i2"
  }, [_vm._v("With garnered gold in wide domain,"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i2"
  }, [_vm._v("Nor heeds the plashing of the rain,"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i0"
  }, [_vm._v("The crashing down of forest trees."), _c('br')])]), _c('div', {
    staticClass: "stanza"
  }, [_c('span', {
    staticClass: "i0"
  }, [_vm._v("O well for him who ne'er hath known"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i2"
  }, [_vm._v("The travail of the hungry years,"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i2"
  }, [_vm._v("A father grey with grief and tears,"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i0"
  }, [_vm._v("A mother weeping all alone."), _c('br')])]), _c('div', {
    staticClass: "stanza"
  }, [_c('span', {
    staticClass: "i0"
  }, [_vm._v("But well for him whose feet hath trod"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i2"
  }, [_vm._v("The weary road of toil and strife,"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i2"
  }, [_vm._v("Yet from the sorrows of his life"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i0"
  }, [_vm._v("Builds ladders to be nearer God."), _c('br')])]), _c('div', {
    staticClass: "stanza"
  }), _c('div', {
    staticClass: "stanza"
  }, [_c('span', {
    staticClass: "i10"
  }, [_vm._v("Oscar F. O'F. Wills Wilde."), _c('br')])]), _c('div', {
    staticClass: "stanza"
  }), _c('div', {
    staticClass: "stanza"
  }, [_c('span', {
    staticClass: "i0"
  }, [_c('i', [_vm._v("S. M. Magdalen College,")]), _c('br')])]), _c('div', {
    staticClass: "stanza"
  }, [_c('span', {
    staticClass: "i5"
  }, [_c('i', [_vm._v("Oxford.")]), _c('br')])])]), _vm._v(" "), _c('hr', {
    staticClass: "chap"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00003",
      "title": "[Pg xii]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_xii",
      "title": "[Pg xii]"
    }
  })])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "pgepubid00004"
    }
  }, [_vm._v("NOTE.")]), _vm._v(" "), _c('p', [_vm._v("M. Gide's Study of Mr. Oscar Wilde (perhaps the\nbest account yet written of the poet's latter days) appeared\nfirst in "), _c('i', [_vm._v("L'Ermitage")]), _vm._v(", a monthly literary review,\nin June, 1902. It was afterwards reprinted with some\nfew slight alterations in a volume of critical essays,\nentitled "), _c('i', [_vm._v("Prétextes")]), _vm._v(", by M. Gide. It is now published in\nEnglish for the first time, by special arrangement with\nthe author.")]), _vm._v(" "), _c('p', {
    staticClass: "signature"
  }, [_vm._v("S. M.")]), _vm._v(" "), _c('hr', {
    staticClass: "chap"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00005",
      "title": "[Pg xiii]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_xiii",
      "title": "[Pg xiii]"
    }
  })])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "pgepubid00006"
    }
  }, [_vm._v("CONTENTS.")]), _vm._v(" "), _c('table', {
    staticClass: "toc"
  }, [_c('tbody', [_c('tr', [_c('td'), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("Page")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Poem by Oscar Wilde")]), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Page_xi"
    }
  }, [_vm._v("xi")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Introductory")]), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Page_1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Inscription on Oscar Wilde's Tombstone")]), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Page_11"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Letters from M. André Gide")]), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Page_12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Oscar Wilde: from the French of André Gide")]), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Page_15"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sonnet 'To Oscar Wilde,' by Augustus M. Moore")]), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Page_89"
    }
  }, [_vm._v("89")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("List of Published Writings of Oscar Wilde")]), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Page_93"
    }
  }, [_vm._v("93")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Bibliographical Notes on The English Editions")]), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Page_107"
    }
  }, [_vm._v("107")])])])])]), _vm._v(" "), _c('hr', {
    staticClass: "r5"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00007",
      "title": "[Pg xiv]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_xiv",
      "title": "[Pg xiv]"
    }
  })])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "pgepubid00008"
    }
  }, [_vm._v("LIST OF ILLUSTRATIONS.")]), _vm._v(" "), _c('table', {
    staticClass: "toc"
  }, [_c('tbody', [_c('tr', [_c('td'), _c('td', {
    staticClass: "tdr"
  }, [_vm._v("Page")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cartoon: 'How Utter'  "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_vm._v("(From a Cartoon published by Messrs. Shrimpton at\nOxford about 1880. By permission of Mr. Hubert Giles, 23 Broad St., Oxford).")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#HOW_UTTER"
    }
  }, [_vm._v("Frontispiece")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Oscar Wilde at Oxford, 1878"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_vm._v("(By permission of Mr. Hubert Giles).")])]), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#OSCAR_WILDE_1878"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Oscar Wilde in 1893"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_vm._v("(From a Photograph by Messrs. Gillman & Co., Oxford).")])]), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#OSCAR_WILDE_1893"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("The Grave at Bagneux"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_vm._v("(By permission of the Proprietors of "), _c('i', [_vm._v("The Sphere")]), _vm._v("\nand "), _c('i', [_vm._v("The Tatler")]), _vm._v(").")])]), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#THE_GRAVE_AT_BAGNEUX"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Reduced Facsimile of the Cover of "), _c('i', [_vm._v("'The Woman's World'")])]), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#THE_WOMANS_WORLD"
    }
  }, [_vm._v("96")])])])])]), _vm._v(" "), _c('hr', {
    staticClass: "tb"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00009",
      "title": "[Pg 1]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_1",
      "title": "[Pg 1]"
    }
  })])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "pgepubid00010"
    }
  }, [_vm._v("Oscar Wilde"), _c('br'), _vm._v("\n\nIntroductory.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Oscar Fingall O'Flahertie Wills Wilde\nwas born at 1 Merrion Square, North, Dublin,\non October 16th, 1854. He was the second\nson of Sir William Robert Wilde, Knight, a celebrated\nsurgeon who was President of the Irish\nAcademy and Chairman of the Census Committee.\nSir William Wilde was born in 1799, and died at\nthe age of seventy-seven years.")]), _vm._v(" "), _c('p', [_vm._v("Oscar Wilde's mother was Jane Francesca,\ndaughter of Archdeacon Elgee. She was born in\n1826, and married in 1851. She became famous\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00011",
      "title": "[Pg 2]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_2",
      "title": "[Pg 2]"
    }
  })]), _vm._v("in literary circles under the pen-names of 'Speranza'\nand 'John Fenshawe Ellis,' among her published\nwritings being "), _c('i', [_vm._v("Driftwood from Scandinavia")]), _vm._v("\n(1884), "), _c('i', [_vm._v("Legends of Ireland")]), _vm._v(" (1886), and "), _c('i', [_vm._v("Social Studies")]), _vm._v("\n(1893). Lady Wilde died at her residence in\nChelsea on February 3rd, 1896"), _c('a', {
    attrs: {
      "id": "FNanchor_1_1"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_1_1"
    }
  }, [_vm._v("[1]")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Oscar Wilde received his early education at Portora\nRoyal School, Enniskillen, which he entered\nin 1864 at the age of nine years. Here he remained\nfor seven years, and, winning a Royal\nscholarship, he entered Trinity College, Dublin,\non October 19th, 1871, being then seventeen years\nof age. In the following year he obtained First\nClass Honours in Classics in Hilary, Trinity and\nMichaelmas Terms; he also won the Gold Medal\nfor Greek"), _c('a', {
    attrs: {
      "id": "FNanchor_2_2"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_2_2"
    }
  }, [_vm._v("[2]")]), _vm._v("  and other distinctions. The Trinity\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00012",
      "title": "[Pg 3]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_3",
      "title": "[Pg 3]"
    }
  })]), _vm._v("College Magazine "), _c('i', [_vm._v("Kottabos")]), _vm._v(", for the years 1876–9,\ncontains some of his earliest published poems. In\n1874 he obtained a classical scholarship"), _c('a', {
    attrs: {
      "id": "FNanchor_3_3"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_3_3"
    }
  }, [_vm._v("[3]")]), _vm._v(", and went\nup to Oxford, where, as a demy, he matriculated\nat Magdalen College on October 17th, the day\nafter his twentieth birthday. His career at Oxford\nwas one unbroken success. In Trinity Term\n(June), 1876, he obtained a First Class in the\nHonour School of Classical Moderations ("), _c('i', [_vm._v("in literis\nGræcis et Latinis")]), _vm._v("), which he followed up two years\nlater by a similar distinction in 'Greats' or 'Honour\nFinals' ("), _c('i', [_vm._v("in literis humanioribus")]), _vm._v("). In this same\nTrinity Term"), _c('a', {
    attrs: {
      "id": "FNanchor_4_4"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_4_4"
    }
  }, [_vm._v("[4]")]), _vm._v(", 1878, he further distinguished himself\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00013",
      "title": "[Pg 4]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_4",
      "title": "[Pg 4]"
    }
  })]), _vm._v("by gaining the Sir Roger Newdigate Prize\nfor English Verse with his poem, 'Ravenna"), _c('a', {
    attrs: {
      "id": "FNanchor_5_5"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_5_5"
    }
  }, [_vm._v("[5]")]), _vm._v(",'\nwhich he recited at the Encænia or Annual Commemoration\nof Benefactors in the Sheldonian\nTheatre on June 26th. He proceeded to the\ndegree of B. A. in the following term"), _c('a', {
    attrs: {
      "id": "FNanchor_6_6"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_6_6"
    }
  }, [_vm._v("[6]")]), _vm._v(". He is\ndescribed in Foster's "), _c('i', [_vm._v("Alumni Oxonienses")]), _vm._v(" as a\n'Professor of Æsthetics and Art critic.'")]), _vm._v(" "), _c('p', [_vm._v("He afterwards lectured on Art in America"), _c('a', {
    attrs: {
      "id": "FNanchor_7_7"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_7_7"
    }
  }, [_vm._v("[7]")]), _vm._v(", 1882,\nand in the provinces on his return to England.\nAbout this time he wrote his poems, "), _c('i', [_vm._v("The Sphinx")]), _vm._v("\nand "), _c('i', [_vm._v("The Harlot's House")]), _vm._v(" (1883), and his tragedy in\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00014",
      "title": "[Pg 5]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_5",
      "title": "[Pg 5]"
    }
  })]), _vm._v("blank verse, "), _c('i', [_vm._v("The Duchess of Padua")]), _vm._v(". The latter\nwas written specially for Miss Mary Anderson,\nbut she did not produce it. This was, however,\nplayed in America by the late Lawrence Barrett in\n1883, as was also another play in blank verse,\nentitled "), _c('i', [_vm._v("Vera, or the Nihilists")]), _vm._v(", during the previous\nyear. He had already published in America and\nEngland a volume of "), _c('i', [_vm._v("Poems")]), _vm._v(", which went through\nseveral editions in a few months.")]), _vm._v(" "), _c('p', [_vm._v("In 1884 Oscar Wilde married"), _c('a', {
    attrs: {
      "id": "FNanchor_8_8"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_8_8"
    }
  }, [_vm._v("[8]")]), _vm._v(" Miss Constance\nMary Lloyd, a daughter of the well-known Q. C.,\nby whom he had two sons, born in June, 1885,\nand November, 1886, respectively. Mrs. Wilde\ndied in 1898, and his only brother, William, in\nMarch of the following year.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00015",
      "title": "[Pg 6]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_6",
      "title": "[Pg 6]"
    }
  })]), _vm._v("During the next five or six years after his marriage,\narticles from his pen appeared in several of\nthe leading reviews, notably 'The Portrait of Mr.\nW. H.' in "), _c('i', [_vm._v("Blackwood's Edinburgh Magazine")]), _vm._v(" for\nJuly, 1889, and those brilliant essays afterwards\nincorporated in "), _c('i', [_vm._v("Intentions")]), _vm._v(", in "), _c('i', [_vm._v("The Nineteenth\nCentury")]), _vm._v(" and "), _c('i', [_vm._v("The Fortnightly Review")]), _vm._v(". In 1888 he\nwas the editor of a monthly journal called "), _c('i', [_vm._v("The\nWoman's World")]), _vm._v(". In July, 1890,"), _c('i', [_vm._v(" The Picture of\nDorian Gray")]), _vm._v(" appeared in "), _c('i', [_vm._v("Lippincott's Monthly\nMagazine")]), _vm._v(". It was the only novel he ever wrote,\nand was published in book form with seven\nadditional chapters in the following year, and\nis one of the most remarkable books in the\nEnglish language.")]), _vm._v(" "), _c('p', [_vm._v("With the production and immediate success of\n"), _c('i', [_vm._v("Lady Windermere's Fan")]), _vm._v(" early in 1892, he was at\nonce recognised as a dramatist of the first rank.\nThis was followed a year later by "), _c('i', [_vm._v("A Woman of\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00016",
      "title": "[Pg 7]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_7",
      "title": "[Pg 7]"
    }
  })]), _vm._v("No Importance")]), _vm._v(", and after brief intervals by "), _c('i', [_vm._v("An\nIdeal Husband")]), _vm._v(" and "), _c('i', [_vm._v("The Importance of Being Earnest")]), _c('a', {
    attrs: {
      "id": "FNanchor_9_9"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_9_9"
    }
  }, [_vm._v("[9]")]), _vm._v(".\nThe two latter were being played in London\nat the time of the author's arrest and trial.")]), _vm._v(" "), _c('p', [_vm._v("Into the melancholy story of his trial it is not\nproposed to enter here beyond mentioning the\nfact that he was condemned by the newspapers,\nand, consequently, by the vast majority of the\nBritish public, several weeks before a jury could\nbe found to return a verdict of 'guilty.' On Saturday,\nMay 25th, 1895, he was sentenced to two\nyears' imprisonment with hard labour, most of\nwhich period was passed at Wandsworth and\nReading.")]), _vm._v(" "), _c('p', [_vm._v("On his release from Reading on Wednesday,\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00017",
      "title": "[Pg 8]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_8",
      "title": "[Pg 8]"
    }
  })]), _vm._v("May 19th, 1897, he at once crossed to France with\nfriends, and a few days later penned that pathetic\nletter, pregnant with pity, in which he pleaded for\nthe kindlier treatment of little children lying in\nour English gaols. This letter, with his own name\nattached, filled over two columns in "), _c('i', [_vm._v("The Daily\nChronicle")]), _vm._v(" of May 28th. It created considerable\nsensation—a well-known Catholic weekly comparing\nit 'in its crushing power to the letter with\nwhich Stevenson shamed the shameless traducer\nof Father Damien.' A second letter on the subject\nof the cruelties of the English Prison system\nappeared in the same paper on March 24th, 1898.\nIt was headed: 'Don't Read This if You Want to\nbe Happy To-day,' and was signed 'The Author\nof "), _c('i', [_vm._v("The Ballad of Reading Gaol")]), _vm._v(".' "), _c('i', [_vm._v("The Ballad of\nReading Gaol")]), _vm._v(" was published early in this same\nyear under the "), _c('i', [_vm._v("nom de plume")]), _vm._v(" 'C.3.3.,' Oscar Wilde's\nprison number. Its authorship was acknowledged\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00018",
      "title": "[Pg 9]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_9",
      "title": "[Pg 9]"
    }
  })]), _vm._v("shortly afterwards in an autograph edition. Since\nthat time countless editions of this famous work\nhave been issued in England and America, and\ntranslations have appeared in French, German and\nSpanish. Of this poem a reviewer in a London\njournal said,—'The whole is awful as the pages of\nSophocles. That he has rendered with his fine art\nso much of the essence of his life and the life of\nothers in that "), _c('i', [_vm._v("inferno")]), _vm._v(" to the sensitive, is a memorable\nthing for the social scientist, but a much more\nmemorable thing for literature. This is a simple,\na poignant, a great ballad, one of the greatest in\nthe English language.'")]), _vm._v(" "), _c('p', [_vm._v("Of the sorrows and sufferings of the last few\nyears of his life, his friend Mr. Robert Harborough\nSherard has written in "), _c('i', [_vm._v("The Story of an Unhappy\nFriendship")]), _vm._v(", and M. Gide refers to them in the following\npages.")]), _vm._v(" "), _c('p', [_vm._v("After several weeks of intense suffering 'Death\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00019",
      "title": "[Pg 10]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_10",
      "title": "[Pg 10]"
    }
  })]), _vm._v("the silent pilot' came at last, and the most brilliant\nwriter of the nineteenth century passed away on\nthe afternoon of November 30th, 1900, in poverty\nand almost alone. The little hotel in Paris—Hotel\nd'Alsace, 13 rue des Beaux Arts,—where\nhe died, has become a place of pilgrimage from all\nparts of the world for those who admire his genius\nor pity his sorrows. He was buried, three days\nlater, in the cemetery at Bagneux, about four\nmiles out of Paris.")]), _vm._v(" "), _c('p', {
    staticClass: "signature"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Stuart Mason.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_1_1"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_1_1"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[1]")])]), _vm._v(" In 1890 Lady Wilde received a pension of £50 from the\nCivil List.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_2_2"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_2_2"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[2]")])]), _vm._v(" The subject for this year, 1874, was 'The Fragments of\nthe Greek Comic Poets, as edited by Meineke.' The medal\nwas presented annually, from a fund left for the purpose by\nBishop Berkeley.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_3_3"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_3_3"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[3]")])]), _vm._v(" The demyship was of the annual value of £95, and was\ntenable for five years. Oscar Wilde's success was announced\nin the "), _c('i', [_vm._v("University Gazette")]), _vm._v(" (Oxford), July 11, 1874.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_4_4"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_4_4"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[4]")])]), _vm._v(" On Wednesday, May 1st, Oscar Wilde, dressed as Prince\nRupert, was present at a fancy dress ball given by Mrs. George\nHerbert Morrell at Headington Hill Hall.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_5_5"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_5_5"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[5]")])]), _vm._v(" 'The Newdigate was listened to with rapt attention and\nfrequently applauded.'—"), _c('i', [_vm._v("Oxford and Cambridge Undergraduates'\nJournal")]), _vm._v(", June 27, 1878.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_6_6"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_6_6"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[6]")])]), _vm._v(" The degree of B. A. was conferred upon him on Thursday,\nNovemher 28, 1878.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_7_7"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_7_7"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[7]")])]), _vm._v(" Amongst the places he visited were New York, Louisville\n(Kentucky), Omaha City and California. In the autumn of\nthis same year, 1882, after leaving the States, Mr. Wilde went\nto Canada and thence to Nova Scotia, arriving at Halifax about\nOctober 8th.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_8_8"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_8_8"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[8]")])]), _vm._v(" The announcement in "), _c('i', [_vm._v("The Times")]), _vm._v(" of May 31, 1884, was as\nfollows:—'May 29, at S. James's Church, Paddington, by the\nRev. Walter Abbott, Vicar, Oscar, younger son of the late\nSir William Wilde, M. D., of Dublin, to Constance Mary, only\ndaughter of the late Horace Lloyd, Esq., Q. C.'")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_9_9"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_9_9"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[9]")])]), _vm._v(" Of "), _c('i', [_vm._v("The Importance of Being Earnest")]), _vm._v(" the author is reported\nto have said, 'The first act is ingenious, the second beautiful,\nthe third abominably clever.' It was revived by Mr. George\nAlexander at the St. James's Theatre on January 7, 1902; and\n"), _c('i', [_vm._v("Lady Windermere's Fan")]), _vm._v(" on November 19, 1904.")])]), _vm._v(" "), _c('hr', {
    staticClass: "tb"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00020",
      "title": "[Pg 11]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_11",
      "title": "[Pg 11]"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "figcenter",
    staticStyle: {
      "width": "119px"
    }
  }, [_c('img', {
    attrs: {
      "alt": "A cross.",
      "id": "id-4419979796294163817",
      "src": "5208151284131596110_ill02.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Oscar Wilde")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Oct. 16th, 1854—Nov. 30th, 1900.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("verbis meis addere nihil audebant\net super illos stillabat eloquium\nmeum.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("JOB XXIX, 22")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("R. I. P.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Inscription on Oscar Wilde's Tombstone.")])]), _vm._v(" "), _c('hr', {
    staticClass: "tb"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00021",
      "title": "[Pg 12]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_12",
      "title": "[Pg 12]"
    }
  })])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "pgepubid00022"
    }
  }, [_c('i', [_vm._v("Letters from M. André Gide.")])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "pgepubid00023"
    }
  }, [_vm._v("I.")]), _vm._v(" "), _c('div', {
    staticClass: "letter"
  }, [_c('div', {
    staticStyle: {
      "margin-left": "50%"
    }
  }, [_c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Château de Cuverville,"), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "2em"
    }
  }, [_vm._v("par Criquetot L'Esneval,")]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "4em"
    }
  }, [_vm._v("Sne. Inferieure.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "dest"
  }, [_vm._v("Monsieur,")]), _vm._v(" "), _c('p', [_vm._v("Quelque plaisir que j'aurai de voir mon\nétude sur Wilde traduite en anglais, je ne puis\nvous répondre avant d'avoir correspondu avec\nmon éditeur. L'article en question, après avoir\nparu dans 'l'Ermitage,' a été réunie à d'autres\nétudes dans un volume, "), _c('i', [_vm._v("Prétextes")]), _vm._v(", que le "), _c('i', [_vm._v("Mercure\nde France")]), _vm._v(" édita l'an dernier. Un traité me lie\nà cette maison et je ne suis pas libre de décider\nseul.")]), _vm._v(" "), _c('p', [_vm._v("Votre lettre a mis quelque temps à me parvenir\nici, où pourtant j'habite. Dès que j'aurai la réponse\ndu "), _c('i', [_vm._v("Mercure de France")]), _vm._v(" je m'empresserai de\nvous la faire savoir.")]), _vm._v(" "), _c('p', [_vm._v("Veuillez croire, Monsieur, à l'assurance de mes\nmeilleurs sentiments.")]), _vm._v(" "), _c('p', {
    staticClass: "signature"
  }, [_vm._v("ANDRÉ GIDE.")]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_c('i', [_vm._v("Septembre 9, 1904.")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00024",
      "title": "[Pg 13]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_13",
      "title": "[Pg 13]"
    }
  })])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "pgepubid00025"
    }
  }, [_vm._v("II.")]), _vm._v(" "), _c('div', {
    staticClass: "letter"
  }, [_c('p', {
    staticClass: "dest"
  }, [_vm._v("Monsieur,")]), _vm._v(" "), _c('p', [_vm._v("Je laisse à mon éditeur le soin de vous\nécrire au sujet des conditions de la publication en\nanglais de mon étude..... Je désire, comme je\nvous le disais, que la traduction que vous proposez\nde faire se reporte au texte donné par le "), _c('i', [_vm._v("Mercure\nde France")]), _vm._v(" dans mon volume "), _c('i', [_vm._v("Prétextes")]), _vm._v(", et non\nà celui, fautif, de 'l'Ermitage.'....")]), _vm._v(" "), _c('p', [_vm._v("Le texte des contes de Wilde que je cite s'éloigne,\nainsi que vous pouvez le voir, du texte anglais que\nWilde lui-même en a donné. Il importe que ce\n"), _c('i', [_vm._v("texte oral")]), _vm._v(" reste différent du texte écrit de ces 'poems\nin prose.' Je crois, si ridicule que cela puisse\nparaître d'abord, qu'il faut retraduire en anglais le\ntexte francais que j'en donne (et que j'ai écrit\npresque sous la dictée de Wilde) et non pas citer\nsimplement le texte anglais tel que Wilde le rédigea\nplus tard. L'effet en est très différent.")]), _vm._v(" "), _c('p', [_vm._v("Veuillez croire, Monsieur, à l'assurance de mes\nsentiments les meilleurs.")]), _vm._v(" "), _c('p', {
    staticClass: "signature"
  }, [_vm._v("ANDRÉ GIDE.")]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_c('i', [_vm._v("Septembre 14th, 1904.")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00026",
      "title": "[Pg 14]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_14",
      "title": "[Pg 14]"
    }
  })])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00027",
      "title": "[Pg 15]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_15",
      "title": "[Pg 15]"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "chap"
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "pgepubid00028"
    }
  }, [_vm._v("Oscar Wilde")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("I was at Biskra in December, 1900, when I\nlearned through the newspapers of the\nlamentable end of Oscar Wilde. Distance, alas!\nprevented me from joining in the meagre procession\nwhich followed his body to the cemetery\nat Bagneux. It was of no use reproaching myself\nthat my absence would seem to diminish still\nfurther the small number of friends who remained\nfaithful to him—at least I wanted to write these\nfew pages at once, but for a considerable period\nWilde's name seemed to become once more the\nproperty of the newspapers.")]), _vm._v(" "), _c('p', [_vm._v("Now that every idle rumour connected with\nhis name, so sadly famous, is hushed; now that\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00029",
      "title": "[Pg 16]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_16",
      "title": "[Pg 16]"
    }
  })]), _vm._v("the mob is at last wearied after having praised,\nwondered at, and then reviled him, perhaps, a friend\nmay be allowed to lay, like a wreath on a forsaken\ngrave, these lines of affection, admiration, and\nrespectful pity.")]), _vm._v(" "), _c('p', [_vm._v("When the trial, with all its scandal, which so\nexcited the public mind in England threatened to\nwreck his life, certain writers and artists attempted\nto carry out, in the name of literature and art, a\nkind of rescue. It was hoped that by praising the\nwriter the man would be excused. Unfortunately,\nthere was a misunderstanding here, for it must be\nacknowledged that Wilde was not a great writer.\nThe leaden buoy which was thrown to him helped\nonly to weigh him down; his works, far from\nkeeping him up, seemed to sink with him. In\nvain were some hands stretched out: the torrent\nof the world overwhelmed him—all was over.")]), _vm._v(" "), _c('hr', {
    staticClass: "r5"
  }), _vm._v(" "), _c('div', {
    staticClass: "figcenter",
    staticStyle: {
      "width": "450px"
    },
    attrs: {
      "aria-labelledby": "ebm_caption1",
      "role": "figure"
    }
  }, [_c('a', {
    attrs: {
      "id": "OSCAR_WILDE_1878"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "",
      "id": "id-4077599181535295752",
      "src": "5208151284131596110_ill03.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption",
    attrs: {
      "id": "ebm_caption1"
    }
  }, [_vm._v("OSCAR WILDE AT OXFORD, 1878.")])]), _vm._v(" "), _c('hr', {
    staticClass: "r5"
  }), _vm._v(" "), _c('p', [_vm._v("It was not possible at that time to think of defending\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00030",
      "title": "[Pg 17]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_17",
      "title": "[Pg 17]"
    }
  })]), _vm._v("him in any other way. Instead of trying\nto shelter the man behind his work, it was necessary\nto show forth first the man as an object of\nadmiration—as I am going to try to do now—and\nthen the work itself illuminated by his personality.\n'I have put all my genius into my life; I have put\nonly my talent into my works,' said Wilde once.\nGreat writer, no, but great "), _c('i', [_vm._v("viveur")]), _vm._v(", yes, if one may\nuse the word in the fullest sense of the French\nterm. Like certain Greek philosophers of old,\nWilde did not write his wisdom, but spoke and\nlived it, entrusting it rashly to the fleeting memory\nof man, thereby writing it as it were on water.")]), _vm._v(" "), _c('p', [_vm._v("Let those who knew him for a longer time than\nI did, tell the story of his life. One of those who\nlistened to him the most eagerly relates here\nsimply a few personal recollections.")]), _vm._v(" "), _c('hr', {
    staticClass: "r35"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00031",
      "title": "[Pg 18]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_18",
      "title": "[Pg 18]"
    }
  })])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00032",
      "title": "[Pg 19]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_19",
      "title": "[Pg 19]"
    }
  })])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "pgepubid00033"
    }
  }, [_vm._v("I.")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('span', {
    staticClass: "i0"
  }, [_vm._v("And the mighty nations would have crowned me, who"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i5"
  }, [_vm._v("am crownless now and without name,"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i0"
  }, [_vm._v("And some orient dawn had found me kneeling on the"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i5"
  }, [_vm._v("threshold of the House of Fame."), _c('br')])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00034",
      "title": "[Pg 20]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_20",
      "title": "[Pg 20]"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "r5"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00035",
      "title": "[Pg 21]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_21",
      "title": "[Pg 21]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Those who became acquainted with Wilde\nonly in the latter years of his life form a\nwrong conception of the wonderful creature he\nformerly was, if they judge from the enfeebled\nand crushed being given back to us from prison,\nas Ernest Lajeunesse paints him, for instance, in\nthe best or rather the only passable article on the\ngreat reprobate which any one has had the talent\nor the courage to write"), _c('a', {
    attrs: {
      "id": "FNanchor_1_10"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_1_10"
    }
  }, [_vm._v("[1]")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("It was in 1891 that I met him for the first time.\nWilde had then what Thackeray calls 'one of the\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00036",
      "title": "[Pg 22]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_22",
      "title": "[Pg 22]"
    }
  })]), _vm._v("greatest of a great man's qualities'—success"), _c('a', {
    attrs: {
      "id": "FNanchor_2_11"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_2_11"
    }
  }, [_vm._v("[2]")]), _vm._v(". His\nmanner and his appearance were triumphant.\nHis success was so assured that it seemed to go\nin front of him, and he had only to advance. His\nbooks were causing wonder and delight. All\nLondon was soon to rush to see his plays"), _c('a', {
    attrs: {
      "id": "FNanchor_3_12"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_3_12"
    }
  }, [_vm._v("[3]")]), _vm._v(". He\nwas rich, he was great, he was handsome, he was\nloaded with happiness and honours.")]), _vm._v(" "), _c('p', [_vm._v("Some compared him to an Asiatic Bacchus,\nothers to some Roman Emperor, and others again\nto Apollo himself,—in short, he was resplendent.\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00037",
      "title": "[Pg 23]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_23",
      "title": "[Pg 23]"
    }
  })]), _vm._v("In Paris his name passed from mouth to\nmouth as soon as he arrived. Several absurd\nsayings went round concerning him, as that after\nall he was only the man who smoked gold-tipped\ncigarettes, and walked about the streets with a\nsunflower in his hand. For, skilful in misleading\nthose who are the heralds of earthly fame, Wilde\nknew how to hide his real personality behind an\namusing phantom, with which he humorously deluded\nthe public.")]), _vm._v(" "), _c('p', [_vm._v("I had heard him talked about at Stéphane Mallarmé's\nhouse, where he was described as a brilliant\nconversationalist, and I expressed a wish to know\nhim, little hoping that I should ever do so. A\nhappy chance, or rather a friend, gave me the\nopportunity, and to him I made known my desire.\nWilde was invited to dinner. It was at a restaurant.\nWe were a party of four, but three of\nus were content to listen. Wilde did not\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00038",
      "title": "[Pg 24]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_24",
      "title": "[Pg 24]"
    }
  })]), _vm._v("converse—he told tales. During the whole meal he\nhardly stopped. He spoke in a slow, musical\ntone, and his very voice was wonderful. He knew\nFrench almost perfectly, but pretended, now and\nthen, to hesitate a little for a word to which he\nwanted to call our attention. He had scarcely\nany accent, at least only what it pleased him to\naffect when it might give a somewhat new or\nstrange appearance to a word—for instance, he\nused purposely to pronounce "), _c('i', [_vm._v("scepticisme")]), _vm._v(" as skepticisme.\nThe stories he told us without a break\nthat evening were not of his best. Uncertain of\nhis audience he was testing us, for, in his wisdom,\nor perhaps in his folly, he never betrayed himself\ninto saying anything which he thought would not\nbe to the taste of his hearers; so he doled out\nfood to each according to his appetite. Those\nwho expected nothing from him got nothing, or\nonly a little light froth, and as at first he used\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00039",
      "title": "[Pg 25]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_25",
      "title": "[Pg 25]"
    }
  })]), _vm._v("to give himself up to the task of amusing, many\nof those who thought they knew him will have\nknown him only as the amuser.")]), _vm._v(" "), _c('p', [_vm._v("When dinner was over we went out. My two\nfriends walking together, Wilde took me aside and\nsaid quite suddenly, 'You hear with your eyes;\nthat is why I am going to tell you this story.'")]), _vm._v(" "), _c('p', [_vm._v("He began:—")]), _vm._v(" "), _c('blockquote', [_c('div', [_c('p', [_vm._v("'When Narcissus died, the Flowers of the\nFields were plunged in grief, and asked the\nRiver for drops of water that they might\nmourn for him.")]), _vm._v(" "), _c('p', [_vm._v("'\"Oh,\" replied the River, \"if all my drops\nof water were tears, I should not have enough\nto weep for Narcissus myself—I loved him.\"")]), _vm._v(" "), _c('p', [_vm._v("'\"How could you help loving Narcissus?\"\nrejoined the Flowers, \"so beautiful was he.\"")]), _vm._v(" "), _c('p', [_vm._v("'\"Was he beautiful?\" asked the River.")]), _vm._v(" "), _c('p', [_vm._v("'\"And who should know that better than\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00040",
      "title": "[Pg 26]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_26",
      "title": "[Pg 26]"
    }
  })]), _vm._v("yourself?\" said the Flowers, \"for, every day,\nlying on your bank, he would mirror his own\nbeauty in your waters.\"'")])])]), _vm._v(" "), _c('p', [_vm._v("Wilde stopped for a moment, and then went\non:—")]), _vm._v(" "), _c('blockquote', [_c('div', [_c('p', [_vm._v("'\"If I loved him,\" replied the River, \"it is\nbecause when he hung over my waters I saw\nthe reflection of my waters in his eyes.\"'")])])]), _vm._v(" "), _c('p', [_vm._v("Then Wilde, drawing himself up, added with a\nstrange outburst of laughter, 'That is called "), _c('i', [_vm._v("The\nDisciple")]), _vm._v(".'")]), _vm._v(" "), _c('p', [_vm._v("We had reached his door, and left him. He\nasked me to meet him again. During the course\nof that year and the next I saw him frequently\nand everywhere.")]), _vm._v(" "), _c('hr', {
    staticClass: "tb"
  }), _vm._v(" "), _c('p', [_vm._v("In the presence of others, as I have mentioned,\nWilde would put on an air of showing off in order\nto astonish, or amuse, or even exasperate people.\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00041",
      "title": "[Pg 27]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_27",
      "title": "[Pg 27]"
    }
  })]), _vm._v("He never listened to, and scarcely took any notice\nof an idea from the moment it was no longer\npurely his own. When he was no longer the\nonly one to shine, he would shut himself up, and\nemerge again only when one found oneself alone\nwith him once more. But as soon as we were\nalone again he would begin, 'Well, what have you\nbeen doing since yesterday?' Now, as at that\ntime my life was passing uneventfully enough,\nthe telling of what I had been doing was of no\ninterest. So, to humour him, I began recounting\nsome trifling incidents, and noticed while I was\nspeaking that Wilde's face was growing gloomy.")]), _vm._v(" "), _c('p', [_vm._v("'You really did that?' he said.")]), _vm._v(" "), _c('p', [_vm._v("'Yes,' I answered.")]), _vm._v(" "), _c('p', [_vm._v("'And you are speaking the truth?'")]), _vm._v(" "), _c('p', [_vm._v("'Absolutely.'")]), _vm._v(" "), _c('p', [_vm._v("'Then why repeat it? You must see that it\nis not of the slightest importance. You must\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00042",
      "title": "[Pg 28]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_28",
      "title": "[Pg 28]"
    }
  })]), _vm._v("understand that there are two worlds—the one\nexists and is never talked about; it is called the\nreal world because there is no need to talk about\nit in order to see it. The other is the world of\nArt; one must talk about that, because otherwise\nit would not exist.'")]), _vm._v(" "), _c('p', [_vm._v("Then he went on:—")]), _vm._v(" "), _c('blockquote', [_c('div', [_c('p', [_vm._v("'Once upon a time there was a man who\nwas beloved in his village because he used to\ntell tales. Every morning he left the village,\nand when he returned in the evening all the\nlabourers of the village who had been working\nall the day would crowd round him and\nsay, \"Come, now, tell us a tale. What have\nyou seen to-day?\"")]), _vm._v(" "), _c('p', [_vm._v("'The man said, \"I have seen in the forest\na Faun playing on a flute and making a band\nof little wood-nymphs dance.\"")]), _vm._v(" "), _c('p', [_vm._v("'\"Go on with your story; what did you\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00043",
      "title": "[Pg 29]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_29",
      "title": "[Pg 29]"
    }
  })]), _vm._v("see?\" the men would say.")]), _vm._v(" "), _c('p', [_vm._v("'\"When I reached the sea-shore, I saw\nthree mermaids beside the waves, combing\ntheir green hair with golden combs.\"")]), _vm._v(" "), _c('p', [_vm._v("'And the villagers loved him because he\nused to tell them tales.")]), _vm._v(" "), _c('p', [_vm._v("'One morning he left his village as usual,\nand when he reached the sea-shore he saw\nthree mermaids at the water's edge combing\ntheir green hair with golden combs. And as\nhe passed on his way he saw, near a wood,\na Faun playing a flute to a band of wood-nymphs.")]), _vm._v(" "), _c('p', [_vm._v("'That evening when he returned to his\nvillage the people said to him as they did\nevery evening, \"Come, tell us a tale: what\nhave you seen?\"")]), _vm._v(" "), _c('p', [_vm._v("'And the man answered, \"I have seen nothing.\"'")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00044",
      "title": "[Pg 30]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_30",
      "title": "[Pg 30]"
    }
  })]), _vm._v("Wilde stopped for a moment to allow the effect\nof the story to sink into me, and then he continued,\n'I do not like your lips; they are quite\nstraight, like the lips of a man who has never\ntold a lie. I want you to learn to lie so that your\nlips may become beautiful and curved like the lips\nof an antique mask.")]), _vm._v(" "), _c('p', [_vm._v("'Do you know what makes the work of art,\nand what makes the work of nature? Do you\nknow what the difference is? For the narcissus\nis as beautiful as a work of art, so what distinguishes\nthem cannot be merely beauty. Do\nyou know what it is that distinguishes them?\nA work of art is always unique. Nature, who\nmakes nothing durable, is ever repeating herself,\nso that nothing she makes may be lost. A single\nnarcissus produces many blooms—that is why\neach one lives but a day. Every time Nature\ninvents a new form she at once makes a "), _c('i', [_vm._v("replica")]), _vm._v(".\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00045",
      "title": "[Pg 31]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_31",
      "title": "[Pg 31]"
    }
  })]), _vm._v("A sea-monster in one sea knows that in another\nsea there is another monster like itself. When\nGod creates in history a Nero, a Borgia or a\nNapoleon He puts another one on one side.\nNo one knows it, but that does not matter; the\nimportant point is that "), _c('i', [_vm._v("one")]), _vm._v(" may be a success. For\nGod makes man, and man makes the work of art.'")]), _vm._v(" "), _c('p', [_vm._v("Forestalling what I was on the point of saying,\nhe proceeded, 'Yes, I know ... one day a great\nrestlessness fell upon the earth, as if, at last,\nNature was going to create something unique,\nsomething quite unique, and Christ is born on\nearth. Yes, I know, quite well, but listen:—")]), _vm._v(" "), _c('blockquote', [_c('div', [_c('p', [_vm._v("'When Joseph of Arimathæa came down in\nthe evening from Mount Calvary where Jesus\nhad just died, he saw on a white stone a\nyoung man seated weeping. And Joseph\nwent near to him and said, \"I understand\nhow great thy grief must be, for certainly\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00046",
      "title": "[Pg 32]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_32",
      "title": "[Pg 32]"
    }
  })]), _vm._v("that Man was a just Man.\" But the young\nman made answer, \"Oh, it is not for that\nthat I am weeping. I am weeping because\nI, too, have wrought miracles. I also have\ngiven sight to the blind, I have healed the\npalsied, and I have raised the dead; I, too,\nhave caused the barren fig-tree to wither\naway, and I have turned water into wine.\nAnd yet they have not crucified me"), _c('a', {
    attrs: {
      "id": "FNanchor_4_13"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_4_13"
    }
  }, [_vm._v("[4]")]), _vm._v(".\"'")])])]), _vm._v(" "), _c('p', [_vm._v("And that Oscar Wilde was convinced of his representative\nmission was made quite clear to me\non more than one occasion.")]), _vm._v(" "), _c('p', [_vm._v("The Gospel disturbed and troubled the pagan\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00047",
      "title": "[Pg 33]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_33",
      "title": "[Pg 33]"
    }
  })]), _vm._v("Wilde. He could not forgive it its miracles. The\npagan miracle lies in the work of Art; Christianity\nencroached on it. Every strong departure from\nrealism in art demands a realism which is convinced\nin life. His most ingenious fables, his\nmost alarming ironies were uttered with a view\nto confront the two moralities—I mean, pagan\nnaturalism and Christian idealism, and to put the\nlatter out of countenance in every respect. This\nis another of his stories:—")]), _vm._v(" "), _c('blockquote', [_c('div', [_c('p', [_vm._v("'When Jesus was minded to return to\nNazareth, Nazareth was so changed that He\nno longer recognised His own city. The\nNazareth where He had lived was full of\nlamentations and tears; this city was filled\nwith outbursts of laughter and song. And\nChrist entering into the city saw some slaves\nladen with flowers, hastening towards the\nmarble staircase of a house of white marble.\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00048",
      "title": "[Pg 34]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_34",
      "title": "[Pg 34]"
    }
  })]), _vm._v("Christ entered into the house, and at the\nback of a hall of jasper He saw, lying on a\npurple couch, a man whose disordered locks\nwere mingled with red roses, and whose lips\nwere red with wine. Christ drew near to him,\nand laying His hand on his shoulder said\nto him, \"Why dost thou lead this life?\" The\nman turned round, recognized Him and said,\n\"I was a leper once; Thou didst heal me.\nWhy should I live another life? \"")]), _vm._v(" "), _c('p', [_vm._v("Christ went out of the house, and behold!\nin the street He saw a woman whose face and\nraiment were painted and whose feet were\nshod with pearls. And behind her walked\na man who wore a cloak of two colours,\nand whose eyes were bright with lust. And\nChrist went up to the man and laid His\nhand on his shoulder, and said to him, \"Tell\nMe why art thou following this woman, and\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00049",
      "title": "[Pg 35]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_35",
      "title": "[Pg 35]"
    }
  })]), _vm._v("why dost thou look at her in such wise?\"\nThe man turning round recognized Him and\nsaid, \"I was blind; Thou didst heal me;\nwhat else should I do with my sight?\"")]), _vm._v(" "), _c('p', [_vm._v("'And Christ drew near to the woman and\nsaid to her, \"This road which thou art following\nis the pathway of sin; why follow\nit?\" The woman recognized Him,\nand laughing said, \"The way which I follow\nis a pleasant way, and Thou hast pardoned\nall my sins.\"")]), _vm._v(" "), _c('p', [_vm._v("'Then Christ felt His heart filled with sadness,\nand He was minded to leave the city.\nBut as He was going out of it He saw sitting\nby the bank of the moat of the city, a young\nman who was weeping. He drew near to\nhim, and touching the locks of his hair, said\nto him, \"Friend, why dost thou weep?\" The\nyoung man raised his eyes, recognized Him\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00050",
      "title": "[Pg 36]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_36",
      "title": "[Pg 36]"
    }
  })]), _vm._v("and made answer, \"I was dead and Thou\nhast raised me to life. What else should I\ndo with my life?\"'")])])]), _vm._v(" "), _c('p', [_vm._v("Let me tell this one story more, illustrating one\nof the strangest pitfalls into which the imagination\ncan mislead a man, and let any one, who is able,\nunderstand the strange paradox which Wilde here\nmakes use of:—")]), _vm._v(" "), _c('blockquote', [_c('div', [_c('p', [_vm._v("'Then there was a great silence in the Judgment\nHall of God. And the Soul of the\nsinner stood naked before God.")]), _vm._v(" "), _c('p', [_vm._v("'And God opened the Book of the life of\nthe sinner and said, \"Surely thy life hath\nbeen very evil. Thou hast\" (there followed a\nwonderful, a marvellous list of sins"), _c('a', {
    attrs: {
      "id": "FNanchor_5_14"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_5_14"
    }
  }, [_vm._v("[5]")]), _vm._v("). \"Since\nthou hast done all this, surely I will send thee\nto Hell.\"")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00051",
      "title": "[Pg 37]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_37",
      "title": "[Pg 37]"
    }
  })]), _vm._v("'And the man cried out, \"Thou canst not\nsend me to Hell.\"")]), _vm._v(" "), _c('p', [_vm._v("'And God said to the man, \"Wherefore can\nI not send thee to Hell?\"")]), _vm._v(" "), _c('p', [_vm._v("'And the man made answer and said, \"Because\nin Hell I have always lived.\"")]), _vm._v(" "), _c('p', [_vm._v("'And there was a great silence in the Judgment\nHall of God.")]), _vm._v(" "), _c('p', [_vm._v("'And God spake and said to the man, \"Seeing\nthat I may not send thee to Hell, I am\ngoing to send thee to Heaven.\"")]), _vm._v(" "), _c('p', [_vm._v("'\"Thou canst not send me to Heaven.\"")]), _vm._v(" "), _c('p', [_vm._v("'And God said to the man, \"Wherefore can\nI not send thee to Heaven?\"")]), _vm._v(" "), _c('p', [_vm._v("'And the man said, \"Because I have never\nbeen able to imagine it.\"")]), _vm._v(" "), _c('p', [_vm._v("'And there was a great silence in the Judgment\nHall of God"), _c('a', {
    attrs: {
      "id": "FNanchor_6_15"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_6_15"
    }
  }, [_vm._v("[6]")]), _vm._v(".'")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00052",
      "title": "[Pg 38]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_38",
      "title": "[Pg 38]"
    }
  })]), _vm._v("One morning Wilde handed me an article in\nwhich a sufficiently dense critic congratulated him\non 'knowing how to write pretty stories in which\nthe better to clothe his thoughts.'")]), _vm._v(" "), _c('p', [_vm._v("'They think,' began Wilde, 'that all thoughts\ncome naked to the birth. They do not understand\nthat I "), _c('i', [_vm._v("cannot")]), _vm._v(" think otherwise than in stories. The\nsculptor does not try to reproduce his thoughts\nin marble; "), _c('i', [_vm._v("he thinks in marble")]), _vm._v(", straight away.\nListen:—")]), _vm._v(" "), _c('blockquote', [_c('div', [_c('p', [_vm._v("'There was once a man who could think\nonly in bronze. And this man one day had\nan idea, an idea of "), _c('i', [_vm._v("The Pleasure that Abideth\nfor a Moment")]), _vm._v(". And he felt that he must give\nexpression to it. But in the whole world there\nwas but one single piece of bronze, for men\nhad used it all up. And this man felt that\nhe would go mad if he did not give expression\nto his idea. And he remembered a piece of\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00053",
      "title": "[Pg 39]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_39",
      "title": "[Pg 39]"
    }
  })]), _vm._v("bronze on the tomb of his wife, a statue which\nhe had himself fashioned to set on the tomb of\nhis wife, the only woman he had ever loved.\nIt was the image of "), _c('i', [_vm._v("The Sorrow that Endureth\nfor Ever")]), _vm._v(". And the man felt that he was becoming\nmad, because he could not give expression\nto his idea. Then he took this image of\nSorrow, of the "), _c('i', [_vm._v("Sorrow that endureth for Ever")]), _vm._v(",\nand broke it up and melted it and fashioned of\nit an Image of Pleasure, of the "), _c('i', [_vm._v("Pleasure that\nabideth for a Moment")]), _vm._v(".'")])])]), _vm._v(" "), _c('p', [_vm._v("Wilde was a believer in a certain fatality besetting\nthe path of the artist, and that the "), _c('i', [_vm._v("Man")]), _vm._v(" is\nat the mercy of the Idea. 'There are,' he used to\nsay, 'artists of two kinds: some supply answers,\nand others ask questions. It is necessary to know\nif one belongs to those who answer or to those\nwho ask questions; for the one who asks questions\nis never the one who answers them. There are\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00054",
      "title": "[Pg 40]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_40",
      "title": "[Pg 40]"
    }
  })]), _vm._v("certain works which wait for their interpretation\nfor a long time. It is because they are giving\nanswers to questions that have not yet been\nasked—for the question often comes a terribly\nlong time after the answer.'")]), _vm._v(" "), _c('p', [_vm._v("And he added further, 'The soul is born old in\nthe body; it is to rejuvenate the soul that the\nbody becomes old. Plato is Socrates young\nagain.'")]), _vm._v(" "), _c('p', [_vm._v("Then it was three years before I saw him\nagain.")]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_1_10"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_1_10"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[1]")])]), _vm._v(" In "), _c('i', [_vm._v("La Revue Blanche")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_2_11"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_2_11"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[2]")])]), _vm._v(" "), _c('i', [_vm._v("Henry Esmond")]), _vm._v(", Book II, chap. "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("xi")]), _vm._v(". Thackeray puts these\nwords into the mouth of the famous Mr. Joseph Addison, who\ncontinues:—''T is the result of all the others; 't is a latent\npower in him which compels the favour of the gods, and subjugates\nfortune.'")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_3_12"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_3_12"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[3]")])]), _vm._v(" Oscar Wilde's first play, "), _c('i', [_vm._v("Lady Windermere's Fan")]), _vm._v(", was\nproduced at the St. James's Theatre on February 20, 1892.\nThis was followed by "), _c('i', [_vm._v("A Woman of No Importance")]), _vm._v(", April 19,\n1893, and "), _c('i', [_vm._v("An Ideal Husband")]), _vm._v(", January, 3, 1895, at Haymarket;\nand "), _c('i', [_vm._v("The Importance of Being Earnest")]), _vm._v(", February 14,\n1895, at the St. James's.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_4_13"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_4_13"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[4]")])]), _vm._v(" This story appeared under the title of 'The Master' with\nother Poems in Prose in "), _c('i', [_vm._v("The Fortnightly Review")]), _vm._v(" for July, 1894.\nTwo of them, 'The Disciple' and 'The House of Judgment,'\nwere first published in "), _c('i', [_vm._v("The Spirit Lamp")]), _vm._v(" in 1893. This was\na magazine published at Oxford under the editorship of Lord\nAlfred Douglas, who had recently bought it from the founder\nand changed its style and form. A complete set of the fifteen\nnumbers is now exceedingly scarce.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_5_14"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_5_14"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[5]")])]), _vm._v(" Henri Davray translated these 'Poems in Prose' in "), _c('i', [_vm._v("La\nRevue Blanche")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_6_15"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_6_15"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[6]")])]), _vm._v(" Since Villiers de l'Isle-Adam has betrayed it, every one\nknows, alas! the great secret of the Church: "), _c('i', [_vm._v("There is no Purgatory!")])])]), _vm._v(" "), _c('hr', {
    staticClass: "r35"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00055",
      "title": "[Pg 41]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_41",
      "title": "[Pg 41]"
    }
  })])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "pgepubid00056"
    }
  }, [_vm._v("II.")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('span', {
    staticClass: "i0"
  }, [_vm._v("I have made my choice, have lived my poems, and"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i5"
  }, [_vm._v("though youth is gone in wasted days,"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i0"
  }, [_vm._v("I have found the lover's crown of myrtle better than"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i5"
  }, [_vm._v("the poet's crown of bays."), _c('br')])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00057",
      "title": "[Pg 42]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_42",
      "title": "[Pg 42]"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "r5"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00058",
      "title": "[Pg 43]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_43",
      "title": "[Pg 43]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Here tragic reminiscences begin.")]), _vm._v(" "), _c('p', [_vm._v("A persistent rumour, growing louder and\nlouder with the fame of his successes (in London\nhis plays were being acted in no less than three\ndifferent theatres at the same time"), _c('a', {
    attrs: {
      "id": "FNanchor_1_16"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_1_16"
    }
  }, [_vm._v("[1]")]), _vm._v("), attributed to\nWilde strange habits, on hearing of which, some\npeople tempered their indignation with a smile,\nwhile others were not in the least indignant. It\nwas claimed, moreover, as regards these alleged\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00059",
      "title": "[Pg 44]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_44",
      "title": "[Pg 44]"
    }
  })]), _vm._v("habits, that he concealed them little, and often on\nthe other hand paraded them—some said courageously,\nothers out of cynicism, and others for a\npose. I was filled with astonishment when I\nheard these rumours. In no way, all the time\nthat I had been intimate with him, had he given\nme the slightest ground for suspicion. But already\nout of prudence numbers of his old friends were\ndeserting him. They did not yet actually cut him,\nbut they no longer made a point of saying they\nhad met him.")]), _vm._v(" "), _c('p', [_vm._v("An extraordinary coincidence brought us together\nagain. It was in January, 1895. I was travelling.\nA peevish disposition urged me on, and I\nsought solitude rather than novelty of scene. The\nweather was frightful. I had fled from Algiers to\nBlidah, and I was about to quit Blidah for Biskra.\nJust as I was leaving my hotel, I glanced, through\nidle curiosity, at the slate on which visitors' names\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00060",
      "title": "[Pg 45]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_45",
      "title": "[Pg 45]"
    }
  })]), _vm._v("were inscribed. What did I see there? By the\nside of my own name, actually touching it, was\nWilde's. I have said that I was thirsting to be\nalone, so I took the sponge and rubbed my name\nout. Before reaching the railway station, however,\nI was not quite sure that a little cowardice did not\nunderlie that act, so at once retracing my steps\nI had my bag taken upstairs and wrote my name\non the slate again.")]), _vm._v(" "), _c('p', [_vm._v("In the three years since I had seen him—for\nI can hardly count a short meeting in Florence\nthe year before—Wilde had certainly changed.\nOne felt that there was less tenderness in his\nlook, that there was something harsh in his\nlaughter and a madness in his joy. He seemed,\nat the same time, to be more sure of pleasing and\nless ambitious to succeed therein. He had grown\nreckless, hardened, and conceited. Strangely\nenough, he no longer spoke in fables, and during\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00061",
      "title": "[Pg 46]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_46",
      "title": "[Pg 46]"
    }
  })]), _vm._v("several days that I tarried there I was not once\nable to draw the shortest tale from him. My first\nimpression was one of astonishment at finding him\nin Algeria.")]), _vm._v(" "), _c('p', [_vm._v("'Oh,' he said to me, 'just now I am fleeing from\nart. I want only to adore the sun. Have you ever\nnoticed how the sun detests thought? The sun\nalways causes thought to withdraw itself and take\nrefuge in the shade. Thought dwelt in Egypt originally,\nbut the sun conquered Egypt; then it lived\nfor a long time in Greece, and the sun conquered\nGreece, then in Italy, and then in France. Nowadays\nall thought is driven back as far as Norway\nand Russia, places where the sun never goes.\nThe sun is jealous of art.'")]), _vm._v(" "), _c('p', [_vm._v("To adore the sun, ah! that was—for him—to\nadore life. Wilde's lyrical adoration was fast becoming\na frenzied madness. A fatality led him on;\nhe could not and would not withdraw himself from\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00062",
      "title": "[Pg 47]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_47",
      "title": "[Pg 47]"
    }
  })]), _vm._v("it. He seemed to devote all his zeal and all his\nworth to over-rating his destiny, and over-reaching\nhimself. '"), _c('i', [_vm._v("My")]), _vm._v(" special duty,' he used to say, 'is to\nplunge madly into amusement.' He used to make\na point of searching for pleasure as one faces an\nappointed duty. Nietzsche surprised me less, on\na later occasion, because I had heard Wilde say,\n'No, not happiness! Certainly not happiness!\nPleasure. One must always set one's heart upon\nthe most tragic.'")]), _vm._v(" "), _c('p', [_vm._v("He would walk about the streets of Algiers\npreceded, escorted, and followed by an extraordinary\nmob of young ruffians. He talked to them\nall, regarded them all with equal delight, and\nthrew them money recklessly. 'I hope to have\nthoroughly demoralized this town,' he told me.\nI thought of Flaubert's saying when he was asked\nwhat kind of reputation he most desired—'that of\nbeing a demoralizer,' he replied. In the face of all\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00063",
      "title": "[Pg 48]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_48",
      "title": "[Pg 48]"
    }
  })]), _vm._v("this I was filled with astonishment, admiration, and\nalarm. I knew of his shaky position, the enmities\nhe had created, and the attacks which were being\nmade upon him, and I knew what dark unrest lay\nhidden beneath his outward pretence of pleasure.")]), _vm._v(" "), _c('p', [_vm._v("On one of those last evenings in Algiers, Wilde\nseemed to have made up his mind not to say a\nsingle serious word. At last I became somewhat\nannoyed at the exaggerated wit of his paradoxes,\nand I said to him, 'You have got something better\nto talk about than this nonsense; you are talking\nto me as if I were the public. You ought rather\nto talk to the public as you know so well how\nto talk to your friends. Why is it your plays\nare not better? The best that is in you,\nyou talk; why do you not write it?' 'Oh,\nwell,' he cried immediately, 'my plays are not\ngood, I know, and I don't trouble about that, but\nif you only knew how much amusement they\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00064",
      "title": "[Pg 49]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_49",
      "title": "[Pg 49]"
    }
  })]), _vm._v("afford! They are nearly all the results of a bet.\nSo was "), _c('i', [_vm._v("Dorian Gray")]), _vm._v("—I wrote that in a few days\nbecause a friend of mine declared that I could not\nwrite a novel. Writing bores me so.'")]), _vm._v(" "), _c('hr', {
    staticClass: "r5"
  }), _vm._v(" "), _c('div', {
    staticClass: "figcenter",
    staticStyle: {
      "width": "450px"
    },
    attrs: {
      "aria-labelledby": "ebm_caption2",
      "role": "figure"
    }
  }, [_c('a', {
    attrs: {
      "id": "OSCAR_WILDE_1893"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "id": "id-1637704223507556225",
      "src": "5208151284131596110_ill04.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption",
    attrs: {
      "id": "ebm_caption2"
    }
  }, [_vm._v("OSCAR WILDE, 1893.")])]), _vm._v(" "), _c('hr', {
    staticClass: "r5"
  }), _vm._v(" "), _c('p', [_vm._v("Then, turning suddenly towards me, he said,\n'Would you like to know the great drama of\nmy life? It is that I have put my genius into\nmy life—I have put only my talent into my\nworks.'")]), _vm._v(" "), _c('p', [_vm._v("It was only too true. The best of his writing is\nbut a poor reflection of his brilliant conversation.\nThose who have heard him talk find him disappointing\nto read. "), _c('i', [_vm._v("Dorian Gray")]), _vm._v(" in its conception\nwas a wonderful story, far superior to "), _c('i', [_vm._v("La Peau de\nChagrin")]), _vm._v(", and far more significant! Alas! when\nwritten, what a masterpiece spoiled. In his most\ndelightful tales literary influence makes itself too\nmuch felt. However graceful they may be, one\nnotices too much literary effort; affectation and\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00065",
      "title": "[Pg 50]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_50",
      "title": "[Pg 50]"
    }
  })]), _vm._v("delicacy of phrase"), _c('a', {
    attrs: {
      "id": "FNanchor_2_17"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_2_17"
    }
  }, [_vm._v("[2]")]), _vm._v(" conceal the beauty of the first\nconception of them. One feels in them, and one\ncannot help feeling in them, the three periods of\ntheir generation. The first idea contained in them\nis very beautiful, simple, profound, and certain to\nmake itself heard; a kind of latent necessity holds\nthe parts firmly together, but from that point\nthe gift stops. The development of the parts is\ndone in an artificial manner; there is a lack of\narrangement about them, and when Wilde elaborates\nhis sentences and endeavours to give them\ntheir full value, he does so by overloading them\nprodigiously with tiny conceits and quaint and\ntrifling fancies. The result is that one's emotion\nis held at bay, and the dazzling of the surface so\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00066",
      "title": "[Pg 51]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_51",
      "title": "[Pg 51]"
    }
  })]), _vm._v("blinds one's eyes and mind, that the deep central\nemotion is lost.")]), _vm._v(" "), _c('p', [_vm._v("He spoke of returning to London, as a well-known\npeer was insulting him, challenging him,\nand taunting him with running away.")]), _vm._v(" "), _c('p', [_vm._v("'But if you go back what will happen? 'I asked\nhim. 'Do you know the risk you are running?'")]), _vm._v(" "), _c('p', [_vm._v("'It is best never to know,' he answered. 'My\nfriends are extraordinary—they beg me to be\ncareful. Careful? but can I be careful? That\nwould be a backward step. I must go on as far\nas possible. I cannot go much further. Something\nis bound to happen ... something else.'")]), _vm._v(" "), _c('p', [_vm._v("Here he broke off, and the next day he left for\nEngland.")]), _vm._v(" "), _c('p', [_vm._v("The rest of the story is well-known. That\n'something else' was hard labour.")]), _vm._v(" "), _c('blockquote', [_c('div', [_c('p', [_vm._v("[I have invented nothing, nor altered anything, in the last\nfew sentences I have quoted. Wilde's words are fixed in my\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00067",
      "title": "[Pg 52]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_52",
      "title": "[Pg 52]"
    }
  })]), _vm._v("mind, and, I might almost say, in my ears. I do not say that\nWilde clearly saw the prison opening to receive him, but I do\nassert that the great and unexpected event which astonished\nand upset London, suddenly changing Oscar Wilde from accuser\ninto accused, did not cause him any surprise.")]), _vm._v(" "), _c('p', [_vm._v("The newspapers, which chose to see in him only a buffoon,\nmisrepresented, as far as they could, the position taken up for\nhis defence, even to the extent of wresting all meaning from it.\nPerhaps some day in the far future it will be seemly to lift this\ndreadful trial out of the mire—but not yet.]")])])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_1_16"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_1_16"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[1]")])]), _vm._v(" "), _c('i', [_vm._v("An Ideal Husband")]), _vm._v(" at the Haymarket and "), _c('i', [_vm._v("The Importance\nof Being Earnest")]), _vm._v(" at the St. James's. Possibly "), _c('i', [_vm._v("Lady Windermere's\nFan")]), _vm._v(" or "), _c('i', [_vm._v("A Woman of No Importance")]), _vm._v(" was being played\nat a suburban theatre at the same time.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_2_17"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_2_17"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[2]")])]), _vm._v(" M. Gide first wrote "), _c('i', [_vm._v("euphuisme")]), _vm._v(" but altered it to "), _c('i', [_vm._v("euphémisme")]), _vm._v("\non republishing his 'Study' in "), _c('i', [_vm._v("Prétextes")]), _vm._v(". Euphuism or 'extreme\nnicety in language' seems to be more appropriate in\nthe present case than euphemism or 'a softening of offensive\nexpressions.'")])]), _vm._v(" "), _c('hr', {
    staticClass: "r35"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00068",
      "title": "[Pg 53]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_53",
      "title": "[Pg 53]"
    }
  })])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "pgepubid00069"
    }
  }, [_vm._v("III.")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('span', {
    staticClass: "i0"
  }, [_vm._v("For the crimson flower of our life is eaten by the cankerworm"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i5"
  }, [_vm._v("of truth."), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i0"
  }, [_vm._v("And no hand can gather up the fallen withered petals"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i5"
  }, [_vm._v("of the rose of youth."), _c('br')])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00070",
      "title": "[Pg 54]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_54",
      "title": "[Pg 54]"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "r5"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00071",
      "title": "[Pg 55]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_55",
      "title": "[Pg 55]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("As soon as he came out of prison, Oscar\nWilde went back to France. At Berneval,\na quiet little village near Dieppe, a certain 'Sebastian\nMelmoth' took up his abode. It was he. As\nI had been the last of his French friends to see\nhim, I wanted to be the first to greet him on\nhis return to liberty, and as soon as I could find\nout his address I hastened to him.")]), _vm._v(" "), _c('p', [_vm._v("I arrived about midday without having previously\nannounced my proposed visit. M. Melmoth,\nwhom T——"), _c('a', {
    attrs: {
      "id": "FNanchor_1_18"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_1_18"
    }
  }, [_vm._v("[1]")]), _vm._v(" with warm cordiality invited to\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00072",
      "title": "[Pg 56]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_56",
      "title": "[Pg 56]"
    }
  })]), _vm._v("Dieppe fairly frequently, was not expected back\ntill the evening. He did not return till midnight.")]), _vm._v(" "), _c('p', [_vm._v("It was as cold as winter. The weather was\natrocious. The whole day I wandered about the\ndeserted beach in low spirits and bored to death.\nHow could Wilde have chosen Berneval to live in,\nI wondered. It was positively mournful. Night\ncame, and I went back to the hotel to engage\na room, the same hotel where Melmoth was\nliving—indeed it was the only one in the place.\nThe hotel, which was clean and pleasantly situated,\ncatered only for second-class boarders, inoffensive\nfolk enough, with whom I had to dine.\nRather poor company for Melmoth, I thought.")]), _vm._v(" "), _c('p', [_vm._v("Fortunately I had a book to read, but it was a\ngloomy evening, and at eleven o'clock I was just\ngoing to abandon my intention of waiting up for\nhim when I heard the rumbling of carriage wheels.\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00073",
      "title": "[Pg 57]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_57",
      "title": "[Pg 57]"
    }
  })]), _vm._v("M. Melmoth had arrived, benumbed with cold.\nHe had lost his overcoat on the way. And, now\nthat he came to think of it, he remembered that a\npeacock's feather which his servant had brought\nhim the previous evening was a bad omen, and\nhad clearly foretold some misfortune about to\nbefall him; luckily it was no worse. But as he\nwas shivering with cold, the hotel was set busy\nto warm some whiskey for him. He hardly said\n'How do you do?' to me. In the presence of\nothers, at least, he did not wish to appear to be at\nall moved. And my own emotion was almost immediately\nstilled on finding Sebastian Melmoth so\nplainly like the Oscar Wilde of old—no longer the\nfrenzied poet of Algeria, but the sweet Wilde\nof the days before the crisis; and I found\nmyself taken back not two years, but four or\nfive. There was the same dreamy look, the same\namused smile, the same voice.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00074",
      "title": "[Pg 58]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_58",
      "title": "[Pg 58]"
    }
  })]), _vm._v("He occupied two rooms, the best in the hotel,\nand he had arranged them with great taste.\nSeveral books lay on the table, and among them\nhe showed me my own "), _c('i', [_vm._v("Nourritures Terrestres")]), _vm._v(",\nwhich had been published lately. A pretty Gothic\nVirgin stood on a high pedestal in a dark corner.")]), _vm._v(" "), _c('p', [_vm._v("Presently we sat down near the lamp, Wilde\ndrinking his grog in little sips. I noticed, now\nthat the light was better, that the skin of his face\nhad become red and common looking, and his\nhands even more so, though they still bore the\nsame rings—one to which he was especially attached\nhad in a reversible bezel an Egyptian\nscarabæus in lapis lazuli. His teeth were dreadfully\ndecayed.")]), _vm._v(" "), _c('p', [_vm._v("We began chatting, and I reminded him of our\nlast meeting in Algiers, and asked him if he remembered\nthat I had almost foretold the approaching\ncatastrophe.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00075",
      "title": "[Pg 59]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_59",
      "title": "[Pg 59]"
    }
  })]), _vm._v("'Did you not know,' I said, 'almost for certain\nwhat was awaiting you in England? You saw\nthe danger and rushed headlong into it, did you\nnot?'")]), _vm._v(" "), _c('p', [_vm._v("Here I think I cannot do better than copy out\nthe pages on which I wrote shortly afterwards as\nmuch as I could remember of what he said.")]), _vm._v(" "), _c('p', [_vm._v("'Oh, naturally,' he replied, 'of course I knew\nthat there would be a catastrophe, either that or\nsomething else; I was expecting it. There was\nbut one end possible. Just imagine—to go any\nfurther was impossible, and that state of things\ncould not last. That is why there had to be some\nend to it, you see. Prison has completely changed\nme"), _c('a', {
    attrs: {
      "id": "FNanchor_2_19"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_2_19"
    }
  }, [_vm._v("[2]")]), _vm._v(". I was relying on it for that. —-is terrible.\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00076",
      "title": "[Pg 60]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_60",
      "title": "[Pg 60]"
    }
  })]), _vm._v("He cannot understand that—he cannot understand\nthat I am not taking up the same existence again.\nHe accuses the others of having changed me—but\none must never take up the same existence again.\nMy life is like a work of art. An artist never\nbegins the same work twice, or else it shows that\nhe has not succeeded. My life before prison was\nas successful as possible. Now all that is finished\nand done with.'")]), _vm._v(" "), _c('p', [_vm._v("He lighted a cigarette and went on: 'The public\nis so dreadful that it knows a man only by the last\nthing he has done. If I were to go back to Paris\nnow, people would see in me only the convict. I\ndo not want to show myself again before I have\nwritten a play. Till then I must be left alone and\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00077",
      "title": "[Pg 61]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_61",
      "title": "[Pg 61]"
    }
  })]), _vm._v("undisturbed.' And he added abruptly, 'Did I not\ndo well to come here? My friends wanted me to\ngo to the South to recruit, because at first I was\nquite worn out. But I asked them to find me, in\nthe North of France, a very small place at the seaside,\nwhere I should see no one, where it was very\ncold and there was hardly ever any sun. Did I\nnot do well to come and live at Berneval? [Outside\nthe weather was frightful.] Here every one\nis most good to me—the Curé especially. I am\nso fond of the little church, and, would you believe\nit, it is called "), _c('i', [_vm._v("Notre Dame de Liesse")]), _c('a', {
    attrs: {
      "id": "FNanchor_3_20"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_3_20"
    }
  }, [_vm._v("[3]")]), _vm._v("! Now, is not\nthat charming? And now I know that I can never\nleave Berneval, because only this morning the Curé\noffered me a perpetual seat in the choir-stalls.")]), _vm._v(" "), _c('p', [_vm._v("And the Custom-house men, poor fellows, are so\nbored here with nothing to do, that I asked them if\nthey had not anything to read, and now I am giving\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00078",
      "title": "[Pg 62]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_62",
      "title": "[Pg 62]"
    }
  })]), _vm._v("them all the elder Dumas' novels. So I must stay\nhere, you see. And the children, oh, the children\nthey adore me. On the day of the Queen's Jubilee\nI gave a grand fête and a big dinner, when I had\nforty children from the school, all of them, and\nthe schoolmaster, to celebrate it. Is not that\nabsolutely charming? You know that I admire\nthe Queen very much. I always have her portrait\nwith me.'")]), _vm._v(" "), _c('p', [_vm._v("And he showed me her portrait by Nicholson,\npinned on the wall. I got up to look at it. A\nsmall bookshelf was close to it, and I began\nglancing at the books. I wanted to lead Wilde\non to talk to me in a more serious vein. I sat\ndown again, and rather timidly asked him if he\nhad read "), _c('i', [_vm._v("Souvenirs de la Maison des Morts")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("He gave me no direct answer, but began:—'Russian\nwriters are extraordinary. What makes\ntheir books so great is the pity they put into\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00079",
      "title": "[Pg 63]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_63",
      "title": "[Pg 63]"
    }
  })]), _vm._v("them. You know how fond I used to be of\n"), _c('i', [_vm._v("Madame Bovary")]), _vm._v(", but Flaubert would not admit\npity into his work, and that is why it has a petty\nand restrained character about it. It is sense\nof pity by means of which a work gains in\nexpanse, and by which it opens up a boundless\nhorizon. Do you know, my dear fellow,\nit was pity that prevented me from killing myself?\nDuring the first six months I was dreadfully\nunhappy, so utterly miserable that I wanted\nto kill myself, but what kept me from doing so\nwas looking at "), _c('i', [_vm._v("the others")]), _vm._v(", and seeing that they\nwere as unhappy as I was, and feeling sorry for\nthem. Oh, dear! what a wonderful thing pity is,\nand I never knew it.'")]), _vm._v(" "), _c('p', [_vm._v("He was speaking in a low voice without any\nexcitement.")]), _vm._v(" "), _c('p', [_vm._v("'Have you ever learned how wonderful a thing\npity is? For my part I thank God every night, yes,\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00080",
      "title": "[Pg 64]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_64",
      "title": "[Pg 64]"
    }
  })]), _vm._v("on my knees I thank God for having taught it to\nme. I went into prison with a heart of stone,\nthinking only of my own pleasure, but now my heart\nis utterly broken—pity has entered into my heart.\nI have learned now that pity is the greatest and\nmost beautiful thing in the world. And that is why\nI cannot bear ill-will towards those who caused\nmy suffering and those who condemned me; no,\nnor to any one, because without them I should\nnot have known all that. —— writes me terrible\nletters. He says he does not understand me,\nthat he does not understand that I do not wish\nevery one ill, and that every one has been horrid\nto me. No, he does not understand me. He\ncannot understand me any more. But I keep\non telling him that in every letter: we cannot\nfollow the same road. He has his, and it is\nbeautiful—I have mine. His is that of Alcibiades;\nmine is now that of St. Francis of Assisi. Do\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "title": "[Pg 65]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_65",
      "title": "[Pg 65]"
    }
  })]), _vm._v("you know St. Francis of Assisi? A wonderful\nman! Would you like to give me a great\npleasure? Send me the best life of St. Francis\nyou can find.'")]), _vm._v(" "), _c('p', [_vm._v("I promised it to him. He went on:")]), _vm._v(" "), _c('p', [_vm._v("'Yes, afterwards we had a charming prison\nGovernor, oh, quite a charming man, but for the\nfirst six months I was dreadfully unhappy. There\nwas a Governor of the prison, a Jew, who was\nvery harsh, because he was entirely lacking in\nimagination.'")]), _vm._v(" "), _c('p', [_vm._v("This last expression, spoken very quickly, was\nirresistibly funny; and, as I laughed heartily, he\nlaughed too, repeated it, and then said:")]), _vm._v(" "), _c('p', [_vm._v("'He did not know what to imagine in order to\nmake us suffer. Now, you shall see what a lack of\nimagination he showed. You must know that in\nprison we are allowed to go out only one hour\na day; then, we walk in a courtyard, round and\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00081",
      "title": "[Pg 66]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_66",
      "title": "[Pg 66]"
    }
  })]), _vm._v("round, one behind the other, and we are absolutely\nforbidden to say a word. Warders watch us,\nand there are terrible punishments for any one\ncaught talking. Those who are in prison for the\nfirst time are spotted at once, because they do\nnot know how to speak without moving their\nlips. I had already been in prison six weeks\nand I had not spoken a word to anyone—not to\na soul"), _c('a', {
    attrs: {
      "id": "FNanchor_4_21"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_4_21"
    }
  }, [_vm._v("[4]")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("'One evening we were walking as usual, one\nbehind the other, during the hour's exercise, when\nsuddenly behind me I heard my name called. It\nwas the prisoner who followed me, and he said,\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00082",
      "title": "[Pg 67]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_67",
      "title": "[Pg 67]"
    }
  })]), _vm._v("\"Oscar Wilde, I pity you, because you must suffer\nmore than we do.\" Then I made a great effort\nnot to be noticed (I thought I was going to faint),\nand I said without turning round, \"No, my friend,\nwe all suffer alike.\" And from that day I no\nlonger had a desire to kill myself. We talked\nin that way for several days. I knew his name\nand what he had done. His name was P——;\nhe was such a good fellow; oh! so good. But\nI had not yet learned to speak without moving\nmy lips, and one evening,—\"C.3.3.\" (C.3.3. was\nmyself), \"C.3.3. and A.4.8. step out of the ranks.\"")]), _vm._v(" "), _c('p', [_vm._v("'Then we stood out, and the warder said, \"You\nwill both have to go before the Governor.\" And\nas pity had already entered into my heart, my\nonly fear was for him; in fact I was even glad\nthat I might suffer for his sake. But the Governor\nwas quite terrible. He had P—— in first; he\nwas going to question us separately, because you\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00083",
      "title": "[Pg 68]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_68",
      "title": "[Pg 68]"
    }
  })]), _vm._v("must know that the punishment is not the same\nfor the one who speaks first, and for the one\nwho answers; the punishment of the one who\nspeaks first is double that of the other. As a rule\nthe first has fifteen days' solitary confinement,\nand the second has eight days only. Then\nthe Governor wanted to know which of us had\nspoken first, and naturally P——, good fellow\nthat he was, said it was he. And afterwards\nwhen the Governor had me in to question me,\nI, of course, said it was I. Then the Governor\ngot very red because he could not understand it.\n\"But P—— also says that it was he who began\nit. I cannot understand it. I cannot understand\nit.\"")]), _vm._v(" "), _c('p', [_vm._v("'Think of it, my dear fellow, he could "), _c('b', [_vm._v("not")]), _vm._v(" understand\nit. He became very much embarrassed and\nsaid, \"But I have already given him fifteen days,\"\nand then he added, \"Anyhow, if that is the\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00084",
      "title": "[Pg 69]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_69",
      "title": "[Pg 69]"
    }
  })]), _vm._v("case, I shall give you both fifteen days.\" Is not\nthat extraordinary? That man had not a spark\nof imagination"), _c('a', {
    attrs: {
      "id": "FNanchor_5_22"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_5_22"
    }
  }, [_vm._v("[5]")]), _vm._v(".'")]), _vm._v(" "), _c('p', [_vm._v("Wilde was vastly amused at what he was saying,\nand laughed—he was happy telling stories.\n'And, of course,' he continued, 'after the fifteen\ndays we were much more anxious to speak to one\nanother than before. You do not know how\nsweet that is, to feel that one is suffering for\nanother. Gradually, as we did not go in the same\norder each day, I was able to talk to each of the\nothers, to all of them, every one of them. I knew\neach one's name and each one's history, and when\neach was due to be released. And to each one\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00085",
      "title": "[Pg 70]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_70",
      "title": "[Pg 70]"
    }
  })]), _vm._v("I said, \"When you get out of prison, the first\nthing you must do is to go to the Post Office, and\nthere you will find a letter for you with some\nmoney.\" And so in that way I still know them,\nbecause I keep up my friendship with them. And\nthere is something quite delightful in them. Would\nyou believe it, already three of them have been to\nsee me here? Is not that quite wonderful?'")]), _vm._v(" "), _c('p', [_vm._v("'The successor of the harsh Governor was a\nvery charming man—oh! remarkably so—and\nmost considerate to me. You cannot imagine\nhow much good it did me in prison that "), _c('i', [_vm._v("Salomé")]), _c('a', {
    attrs: {
      "id": "FNanchor_6_23"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_6_23"
    }
  }, [_vm._v("[6]")]), _vm._v("\nwas being played in Paris just at that time. In\nprison, it had been entirely forgotten that I was\na literary person, but when they saw that my play\nwas a success in Paris, they said to one another,\n\"Well, but that is strange; he has talent, then.\"\nAnd from that moment they let me have all the\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00086",
      "title": "[Pg 71]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_71",
      "title": "[Pg 71]"
    }
  })]), _vm._v("books I wanted to read"), _c('a', {
    attrs: {
      "id": "FNanchor_7_24"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_7_24"
    }
  }, [_vm._v("[7]")]), _vm._v(". I thought, at first, that\nwhat would please me most would be Greek literature,\nso I asked for Sophocles, but I could not get\na relish for it. Then I thought of the Fathers of\nthe Church, but I found them equally uninteresting.\nAnd suddenly I thought of Dante. Oh!\nDante. I read Dante every day, in Italian, and\nall through, but neither the "), _c('i', [_vm._v("Purgatorio")]), _vm._v(" nor the\n"), _c('i', [_vm._v("Paradiso")]), _vm._v(" seemed written for me. It was his\n"), _c('i', [_vm._v("Inferno")]), _vm._v(" above all that I read; how could I help\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00087",
      "title": "[Pg 72]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_72",
      "title": "[Pg 72]"
    }
  })]), _vm._v("liking it? Cannot you guess? Hell, we were in\nit—Hell, that was prison!'"), _c('a', {
    attrs: {
      "id": "FNanchor_8_25"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_8_25"
    }
  }, [_vm._v("[8]")])]), _vm._v(" "), _c('p', [_vm._v("That same evening he told me a clever story\nabout Judas, and of his proposed drama on\nPharaoh. Next day he took me to a charming\nlittle house"), _c('a', {
    attrs: {
      "id": "FNanchor_9_26"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_9_26"
    }
  }, [_vm._v("[9]")]), _vm._v(", about two hundred yards from the\nhotel, which he had rented and was beginning to\nfurnish. It was there that he wanted to write his\nplays—his "), _c('i', [_vm._v("Pharoah")]), _vm._v(" first, and then one called\n"), _c('i', [_vm._v("Ahab and Jezebel")]), _vm._v(" (he pronounced it 'Isabelle'),\nwhich he related to me admirably.")]), _vm._v(" "), _c('p', [_vm._v("The carriage which was to take me away was\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00088",
      "title": "[Pg 73]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_73",
      "title": "[Pg 73]"
    }
  })]), _vm._v("waiting, and Wilde got into it to accompany me\npart of the way. He began talking to me again\nabout my book, and praised it, though with some\nslight reserve, I thought. At last the carriage\nstopped; he bade me good-bye, and was just going\nto get out, when he suddenly said, 'Listen, my\ndear friend, you must promise me one thing.\nYour "), _c('i', [_vm._v("Nourritures Terrestres")]), _vm._v(" is good, very good,\nbut promise me you will never write a capital\n\"I\" again.' And as I seemed scarcely to understand\nwhat he meant, he finished up by saying,\n'In Art, you see, there is no first person.'")]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_1_18"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_1_18"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[1]")])]), _vm._v(" A literary friend who, a few years later, in collaboration,\nwith another, translated "), _c('i', [_vm._v("Dorian Gray")]), _vm._v(" into French.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_2_19"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_2_19"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[2]")])]), _vm._v(" 'No more beautiful life has any man lived, no more beautiful\nlife could any man live than Oscar Wilde lived during the\nshort period I knew him in prison. He wore upon his face an\neternal smile; sunshine was on his face, sunshine of some\nsort must have been in his heart. People say he was not sincere:\nhe was the very soul of sincerity when I knew him. If\nhe did not continue that life after he left prison, then the forces\nof evil must have been too strong for him. But he tried, he\nhonestly tried, and in prison he succeeded.'—"), _c('i', [_vm._v("From a Letter\nwritten to the Translator")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_3_20"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_3_20"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[3]")])]), _vm._v(" An archaic French word from the Latin "), _c('i', [_vm._v("laetitia")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_4_21"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_4_21"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[4]")])]), _vm._v(" Within the last few years the stringency of this regulation\nhas been somewhat relaxed, and it is in the discretion of the\nGovernor to allow conversation at certain times. The Governor\nof Reading Prison, in the appendix to the Report of the Commissioners\nfor the year ending March 31, 1901, stated: 'The\nprivilege of talking at exercise is much appreciated by the\nprisoners. They walk and talk in a quiet and orderly manner,\nand there have been no reports for misbehaviour.'")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_5_22"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_5_22"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[5]")])]), _vm._v(" Solitary confinement does not mean in a dark cell. The\nprisoner still remains in his own cell, but is debarred from\nexercising with the other prisoners, or accompanying them to\nDivine Service. The confinement is not consecutive, but\napplies to every alternate day only—thus, a prisoner sentenced\nto seven days' bread and water, or solitary confinement, does\nbut four days.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_6_23"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_6_23"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[6]")])]), _vm._v(" "), _c('i', [_vm._v("Salome")]), _vm._v(" was played in Paris early in 1896.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_7_24"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_7_24"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[7]")])]), _vm._v(" Oscar Wilde found the prison library quite unable to\nsatisfy his wants, and he was allowed to receive books from\noutside. Such books are then added to the prison library.\nMagazines are forbidden, but novels allowed. In a letter\nwritten from prison early in 1897, Oscar Wilde said that he\nfelt a horror of returning to the world without possessing\na single volume of his own, and suggested that some of his\nfriends might like to give him some books. 'You know what\nkind of books I want,' he says, 'Flaubert, Stevenson, Baudelaire,\nMaeterlinck, Dumas père, Keats, Marlowe, Chatterton,\nColeridge, Anatole France, Théophile Gautier, Dante, and\nGoethe, and so on.'")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_8_25"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_8_25"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[8]")])]), _vm._v(" During the last three months or so of his imprisonment he\ndid no work whatever beyond writing "), _c('i', [_vm._v("De Profundis")]), _vm._v(" and keeping\nhis cell clean. He was allowed gas in his cell up to a late\nhour, when it was turned down but not turned out. As everything\nhe wrote was examined by the Governor, naturally the\nprison system is not attacked with the same vehemence in "), _c('i', [_vm._v("De\nProfundis")]), _vm._v(" as it is in "), _c('i', [_vm._v("The Ballad of Reading Gaol")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_9_26"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_9_26"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[9]")])]), _vm._v(" This was the Chalet Bourbat where Wilde lived from\nJuly to October, 1897.")])]), _vm._v(" "), _c('hr', {
    staticClass: "r35"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00089",
      "title": "[Pg 74]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_74",
      "title": "[Pg 74]"
    }
  })])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00090",
      "title": "[Pg 75]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_75",
      "title": "[Pg 75]"
    }
  })])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "pgepubid00091"
    }
  }, [_vm._v("IV.")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('span', {
    staticClass: "i0"
  }, [_vm._v("Ah! what else had I to do but love you, God's own"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i5"
  }, [_vm._v("mother was less dear to me,"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i0"
  }, [_vm._v("And less dear the Cytheræan rising like an argent lily"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i5"
  }, [_vm._v("from the sea."), _c('br')])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00092",
      "title": "[Pg 76]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_76",
      "title": "[Pg 76]"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "r5"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00093",
      "title": "[Pg 77]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_77",
      "title": "[Pg 77]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("On returning to Paris I went to give news of\nhim to ——.")]), _vm._v(" "), _c('p', [_vm._v("---- said to me: 'But all that is quite absurd.\nHe is quite incapable of bearing the "), _c('i', [_vm._v("ennui")]), _vm._v(". I\nknow him so well. He writes to me every day.\nI also am of opinion that he ought to finish his\nplay first, but after that he will come back here.\nHe has never done anything good in solitude; he\nneeds to be constantly drawn out of himself. It\nis by my side that he has written all his best\nwork. Besides, just look at his last letter.'")]), _vm._v(" "), _c('p', [_vm._v("He thereupon read it to me. In it Wilde\nbegged —— to let him finish his "), _c('i', [_vm._v("Pharaoh")]), _vm._v(" in\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00094",
      "title": "[Pg 78]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_78",
      "title": "[Pg 78]"
    }
  })]), _vm._v("peace, but, in effect, the letter implied that as\nsoon as his play was written he would come back,\nhe would find him again; and it ended with these\nboastful words, 'and then I shall be once more the\nKing of Life.'")]), _vm._v(" "), _c('hr', {
    staticClass: "r35"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00095",
      "title": "[Pg 79]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_79",
      "title": "[Pg 79]"
    }
  })])]), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "pgepubid00096"
    }
  }, [_vm._v("V.")]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('span', {
    staticClass: "i0"
  }, [_vm._v("Rudderless, we drift athwart a tempest, and when once"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i5"
  }, [_vm._v("the storm of youth is past,"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i0"
  }, [_vm._v("Without lyre, without lute or chorus, Death the silent"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i5"
  }, [_vm._v("pilot comes at last."), _c('br')])])]), _vm._v(" "), _c('hr', {
    staticClass: "r5"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00097",
      "title": "[Pg 80]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_80",
      "title": "[Pg 80]"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "figcenter",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "aria-labelledby": "ebm_caption3",
      "role": "figure"
    }
  }, [_c('a', {
    attrs: {
      "id": "THE_GRAVE_AT_BAGNEUX"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "id": "id-7682602926393594131",
      "src": "5208151284131596110_ill05.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption",
    attrs: {
      "id": "ebm_caption3"
    }
  }, [_vm._v("THE GRAVE AT BAGNEUX.")])]), _vm._v(" "), _c('hr', {
    staticClass: "r5"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00098",
      "title": "[Pg 81]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_81",
      "title": "[Pg 81]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("And a short time afterwards, Wilde went back\nto Paris."), _c('a', {
    attrs: {
      "id": "FNanchor_1_27"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_1_27"
    }
  }, [_vm._v("[1]")])]), _vm._v(" "), _c('p', [_vm._v("His play was not written—it will never be written\nnow. Society well knows what steps to take when\nit wants to crush a man, and it has means more\nsubtle than death. Wilde had suffered too grievously\nfor the last two years, and in too submissive\na manner, and his will had been broken. For the\nfirst few months he might still have entertained\nillusions, but he soon gave them up. It was as\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00099",
      "title": "[Pg 82]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_82",
      "title": "[Pg 82]"
    }
  })]), _vm._v("though he had signed his abdication. Nothing\nremained in his shattered life but a mouldy ruin,\npainful to contemplate, of his former self. At\ntimes he seemed to wish to show that his brain\nwas still active. Humour there was, but it was\nfar-fetched, forced, and threadbare.")]), _vm._v(" "), _c('p', [_vm._v("I met him again on two occasions only. One\nevening on the Boulevards, where I was walking\nwith G——, I heard my name called. I turned\nround and saw Wilde. Ah! how changed he\nwas. 'If I appear again before writing my play,\nthe world will refuse to see in me anything\nexcept the felon,' he had once said to me. He\nhad appeared again, without his play, and as he\nfound certain doors closed in his face, he no longer\nsought admission anywhere. He prowled.")]), _vm._v(" "), _c('p', [_vm._v("Friends, at different times, tried to save him"), _c('a', {
    attrs: {
      "id": "FNanchor_2_28"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_2_28"
    }
  }, [_vm._v("[2]")]), _vm._v(".\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00100",
      "title": "[Pg 83]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_83",
      "title": "[Pg 83]"
    }
  })]), _vm._v("They did all they could think of, and were for\ntaking him to Italy, but he eluded their efforts,\nand began to drift back. Among those who had\nremained faithful for the longest time, some\nhad often told me that Wilde was no longer\nto be seen, and I was somewhat uneasy, I admit,\nat seeing him again, and what is more, in a place\nwhere so many people might pass. Wilde was\nsitting at a table outside a café. He ordered two\ncock-tails for G—— and myself. I was going to\nsit opposite to him in such a way as to turn my\nback to the passers-by, but Wilde, noticed this\nmovement, which he took as an impulse of absurd\nshame, (he was not entirely mistaken, I must\nadmit), and said, 'Oh, sit here, near me,' pointing\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "title": "[Pg 84]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_84",
      "title": "[Pg 84]"
    }
  })]), _vm._v("to a chair at his side, 'I am so much alone just\nnow.'")]), _vm._v(" "), _c('p', [_vm._v("Wilde was still well-dressed, but his hat was\nnot so glossy; his collar was of the same shape,\nbut it was not so clean, and the sleeves of his coat\nwere slightly frayed at the edges.")]), _vm._v(" "), _c('p', [_vm._v("'When I used to meet Verlaine in days gone\nby,' he continued with an outburst of pride, 'I was\nnever ashamed of being seen with him. I was\nrich, light-hearted, and covered with glory, but I\nfelt that to be seen with him was an honour, even\nwhen Verlaine was drunk.' Then fearing to bore\nG——, I think, he suddenly changed his mood,\ntried to be witty and to make jokes. In the effort\nhe became gloomy. My recollections here are\ndreadfully sad. At last my friend and I got up.\nWilde insisted on paying for the drinks, and\nI was about to say good-bye, when he took\nme aside, and, with an air of great embarrassment,\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00101",
      "title": "[Pg 85]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_85",
      "title": "[Pg 85]"
    }
  })]), _vm._v("said in a low voice, 'I say, I must tell you,\nI am absolutely without a penny"), _c('a', {
    attrs: {
      "id": "FNanchor_3_29"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_3_29"
    }
  }, [_vm._v("[3]")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Some days afterwards I saw him again, and for\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00102",
      "title": "[Pg 86]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_86",
      "title": "[Pg 86]"
    }
  })]), _vm._v("the last time. I do not want to repeat more than\none word of our conversation. He told me of his\ntroubles, of the impossibility of carrying out, or\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "title": "[Pg 87]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_87",
      "title": "[Pg 87]"
    }
  })]), _vm._v("even of beginning, a piece of work"), _c('a', {
    attrs: {
      "id": "FNanchor_4_30"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_4_30"
    }
  }, [_vm._v("[4]")]), _vm._v(". Sadly I reminded\nhim of the promise he had made not to\nshow himself in Paris without having finished one\nbook. 'Ah!' I began, 'why did you leave Berneval\nso soon, when you ought to have stayed there\nso long? I cannot say that I am angry with you,\nbut—'")]), _vm._v(" "), _c('p', [_vm._v("He interrupted me, laid his hand on mine,\nlooked at me with his most sorrowful look, and\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00103",
      "title": "[Pg 88]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_88",
      "title": "[Pg 88]"
    }
  })]), _vm._v("said, 'You must not be angry with "), _c('i', [_vm._v("one who has\nbeen crushed")]), _c('a', {
    attrs: {
      "id": "FNanchor_5_31"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_5_31"
    }
  }, [_vm._v("[5]")]), _vm._v(".'")]), _vm._v(" "), _c('hr', {
    staticClass: "tb"
  }), _vm._v(" "), _c('p', [_vm._v("Oscar Wilde died in a shabby little hotel in the\nRue des Beaux Arts. Seven persons followed\nthe hearse, and even they did not all accompany\nthe funeral procession to the end. On the coffin\nwere some flowers and some artificial wreaths,\nonly one of which, I am told, bore any inscription.\nIt was from the proprietor of the hotel,\nand on it were these words: '"), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Mon Locataire.")]), _vm._v("'")]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_1_27"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_1_27"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[1]")])]), _vm._v(" The representatives of his family were willing to guarantee\nWilde a very good position if he would consent to certain\nstipulations, one of which was that he should never see ——\nagain. He was either unable or unwilling to accept the\nconditions.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_2_28"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_2_28"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[2]")])]), _vm._v(" In October, 1897, he stayed with friends at the Villa\nGindice, Posillipo, and was in Naples till the end of the year,\nor the beginning of 1898, when he went to Paris. In the\nfollowing year he went to the South of France (Nice) for the\nspring, but was back in June or July. He went also to\nSwitzerland in 1899 and stayed some time at Gland.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_3_29"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_3_29"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[3]")])]), _vm._v(" M. Gide says that Wilde's words were '"), _c('i', [_vm._v("je suis absolument\nsans ressources")]), _vm._v(",' which, I think, need not mean more than\na temporary embarrassment. I have been at some pains to\nfind out what the actual circumstances were, and I am able to\nstate the following facts on the authority of Lord Alfred\nDouglas. When Mr. Wilde came out of prison, the sum of\n£800 was subscribed for him by his friends. Lord Alfred\nDouglas gave or sent Mr. Wilde, in the last twelve months\nof his life, cheques for over £600, as he can show by his\nbank-book, in addition to ready money gifts, and several\nothers gave him at various times amounts totalling up to\nseveral hundreds of pounds. 'It is true,' Lord Alfred Douglas\nwrites, 'he was always hard up and short of money, but that\nwas because he was incurably extravagant and reckless. I\nthink these facts ought to be known in justice to myself and\nmany others of his friends, all poor men.' In another letter\nLord Alfred Douglas says that Mr. Wilde, when he was well\noff, before his disaster, was the most generous of men. After\n1897 received also large sums of money as advance fees for\nplays which he never finished. 'I hope,' Lord Alfred Douglas\ncontinues, 'you will not think that I blame him, or have\nany grievance against him on any account. What I gave\nhim I considered I owed him, as he had often lent and given\nme money before he came to grief. I was delighted that he\nshould have it, and I wish I had had time to give him more.'\nIt was not, however, till after the death of his father, that\nLord Alfred Douglas was in a position to help Mr. Wilde to\nthe extent that he did, and Mr. Wilde died within a few\nmonths of the death of Lord Queensberry.\n")]), _vm._v(" "), _c('p', [_vm._v("\nLord Alfred Douglas adds that he thinks 'it is about time\nthat some of the poisonous nonsense which has been written\nabout Mr. Wilde should be qualified by a little fact.'\n")]), _vm._v(" "), _c('p', [_vm._v("\nIt must be remembered, however, that large as the sums of\nmoney were which Mr. Wilde received during the last few\nyears of his life, they would not appear so to him, as in the\ndays of his highest success he was receiving several thousands\na year from his plays and other works.\n")]), _vm._v(" "), _c('p', [_vm._v("\nIt is since the first sheets of this book passed through the\npress that I have been favoured with the information that\nLord Alfred Douglas has been good enough to give me, and\nI now wish to qualify the statement in my introductory remarks\nthat Mr. Wilde died 'in poverty.' It would be more\naccurate to say 'in comparative poverty.'")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_4_30"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_4_30"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[4]")])]), _vm._v(" Two plays produced in London shortly hefore his death\nhave been attributed to Oscar Wilde. One of these, "), _c('i', [_vm._v("The\nTyranny of Tears")]), _vm._v(", does not contain a single line of his. The\nother is "), _c('i', [_vm._v("Mr. and Mrs. Daventry")]), _vm._v(", the plot of which was originally\nOscar Wilde's, and he sketched out the scenario. The\nplay was then sold to Mr. Frank Harris, who has always\nacknowledged Wilde's share in it, but the piece was entirely\ntransformed, and except one or two of the situations in it there\nwas very little left of Wilde's idea.\n")]), _vm._v(" "), _c('p', [_vm._v("\nReferring to such works as the translations of "), _c('i', [_vm._v("Ce Qui ne\nMeurt pas")]), _vm._v(" and the "), _c('i', [_vm._v("Satyricon")]), _vm._v(" which have heen issued under\nOscar Wilde's name, Mr. Robert Ross (the editor of "), _c('i', [_vm._v("De Profundis")]), _vm._v("),\nwrites:—'No one can produce even a scrap of MS. in\nthe author's handwriting of these so-called \"last works.\"'")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_5_31"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_5_31"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[5]")])]), _vm._v(" 'Scandals used to lend charm, or at least interest, to\na man—now they crush him.'—"), _c('i', [_vm._v("An Ideal Husband")]), _vm._v(", Act I.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00104",
      "title": "[Pg 89]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_89",
      "title": "[Pg 89]"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "chap"
  }), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "pgepubid00105"
    }
  }, [_vm._v("TO OSCAR WILDE,")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_c('b', [_vm._v("Author of 'Ravenna.'")])]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("By Augustus M. Moore.")])]), _vm._v(" "), _c('div', {
    staticClass: "poem"
  }, [_c('div', {
    staticClass: "stanza"
  }, [_c('span', {
    staticClass: "i0"
  }, [_vm._v("No Marsyas am I, who singing came"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i4"
  }, [_vm._v("To challenge King Apollo at a Test,"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i4"
  }, [_vm._v("But a love-wearied singer at the best."), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i0"
  }, [_vm._v("The myrtle leaves are all that I can claim,"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i0"
  }, [_vm._v("While on thy brow there burns a crown of flame,"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i4"
  }, [_vm._v("Upon thy shield Italia's eagle crest;"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i4"
  }, [_vm._v("Content am I with Lesbian leaves to rest,"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i0"
  }, [_vm._v("Guard thou thy laurels and thy mother's name."), _c('br')])]), _c('div', {
    staticClass: "stanza"
  }, [_c('span', {
    staticClass: "i0"
  }, [_vm._v("I buried Love within the rose I meant"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i4"
  }, [_vm._v("To deck the fillet of thy Muse's hair;"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i0"
  }, [_vm._v("I take this wild-flower, grown against her feet,"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i4"
  }, [_vm._v("And kissing its half-open lips I swear,"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i0"
  }, [_vm._v("Frail though it be and widowed of its scent,"), _c('br')]), _vm._v(" "), _c('span', {
    staticClass: "i4"
  }, [_vm._v("I plucked it for your sake and find it sweet."), _c('br')])]), _c('div', {
    staticClass: "stanza"
  }, [_c('span', {
    staticClass: "i2"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Moore Hall,")]), _c('br')])]), _c('div', {
    staticClass: "stanza"
  }, [_c('span', {
    staticClass: "i4"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("September, 1878.")]), _c('br')])]), _c('div', {
    staticClass: "stanza"
  }, [_c('span', {
    staticClass: "i10"
  }, [_vm._v("From "), _c('i', [_vm._v("The Irish Monthly")]), _vm._v(", Vol. vi, No. 65."), _c('br')])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00106",
      "title": "[Pg 90]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_90",
      "title": "[Pg 90]"
    }
  })])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00107",
      "title": "[Pg 91]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_91",
      "title": "[Pg 91]"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "chap"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00108",
      "title": "[Pg 92]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_92",
      "title": "[Pg 92]"
    }
  })])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00109",
      "title": "[Pg 93]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_93",
      "title": "[Pg 93]"
    }
  })])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "pgepubid00110"
    }
  }, [_vm._v("LIST OF PUBLISHED WRITINGS\nOF OSCAR WILDE.")]), _vm._v(" "), _c('p', [_vm._v("Αἴλινον, αἴινον εἰπὲ, Τὸ δ᾽ ευ̉ νικάτω. "), _c('i', [_vm._v("Dublin University\nMagazine")]), _vm._v(", September, 1876.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Apologia")]), _vm._v(". "), _c('i', [_vm._v("Poets and Poetry of the Century")]), _vm._v(", Edited by\nA. H. Miles, Vol. viii, 1891, 1898.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Artist, The")]), _vm._v(". In 'Poems in Prose.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Artist's Dream, The")]), _vm._v(". "), _c('i', [_vm._v("Green Room")]), _vm._v(", Routledge's Christmas\nAnnual, 1880.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Ave Imperatrix! A Poem on England")]), _vm._v(". "), _c('i', [_vm._v("World")]), _vm._v(", August\n25, 1880.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Ave! Maria")]), _vm._v(". "), _c('i', [_vm._v("Kottabos")]), _vm._v(", Michaelmas Term, 1879.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Ballad of Reading Gaol, The")]), _vm._v(". Leonard Smithers, 1898\n(February), 7th Edition, 1899.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Birthday of the Infanta, The")]), _vm._v(". ("), _c('i', [_vm._v("Le Figaro Illustré")]), _vm._v(",\nChristmas Number?). In 'A House of Pomegranates.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Canterville Ghost, The")]), _vm._v(". Illustrations by F. H.\nTownsend. "), _c('i', [_vm._v("Court and Society Review")]), _vm._v(", February 23,\nMarch 2, 1887. In 'Lord Arthur Savile's Crime and\nOther Stories.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Case of Warder Martin, The")]), _vm._v(". "), _c('i', [_vm._v("Daily Chronicle")]), _vm._v(", May\n28, 1897.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Children in Prison")]), _vm._v(". Murdoch & Co., 1898 (February).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00111",
      "title": "[Pg 94]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_94",
      "title": "[Pg 94]"
    }
  })]), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Chinese Sage, A")]), _vm._v(". "), _c('i', [_vm._v("Speaker")]), _vm._v(", February 8, 1890")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Conqueror of Time, The")]), _vm._v(". "), _c('i', [_vm._v("Time")]), _vm._v(", April, 1879.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Critic as Artist, The")]), _vm._v(". In 'Intentions.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("De Profundis")]), _vm._v(". Methuen & Co., 1905 (February 23),\n4th Edition, March, 1905.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Decay of Lying, The. A Dialogue")]), _vm._v(". "), _c('i', [_vm._v("Nineteenth Century")]), _vm._v(",\nJanuary, 1889. In 'Intentions.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Devoted Friend, The")]), _vm._v(". In 'The Happy Prince and Other\nTales.'")]), _vm._v(" "), _c('p', [_vm._v("Δηξίθυμον Ἔρωτος Ἄνθος. "), _c('i', [_vm._v("Kottabos")]), _vm._v(", Trinity Term, 1876.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Disciple, The")]), _vm._v(". "), _c('i', [_vm._v("Spirit Lamp")]), _vm._v(", June 6, 1893. In 'Poems in\nProse.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Doer of Good, The")]), _vm._v(". In 'Poems in Prose.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Dole of the King's Daughter, The")]), _vm._v(". "), _c('i', [_vm._v("Dublin University\nMagazine")]), _vm._v(", June, 1876.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Don't Read This if You Want to be Happy To-day")]), _vm._v(".\n"), _c('i', [_vm._v("Daily Chronicle")]), _vm._v(", March 24, 1898.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Duchess of Padua, The")]), _vm._v(". Privately printed for the\nAuthor; America, 1883"), _c('a', {
    attrs: {
      "id": "FNanchor_1_32"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_1_32"
    }
  }, [_vm._v("[1]")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("English Poetesses")]), _vm._v(". "), _c('i', [_vm._v("Queen")]), _vm._v(", December 8, 1888.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00112",
      "title": "[Pg 95]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_95",
      "title": "[Pg 95]"
    }
  })]), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("English Renaissance, Lecture on the")]), _vm._v(". G. Munro's\n"), _c('i', [_vm._v("Seaside library")]), _vm._v(", Vol. 58, No. 1183. New York,\nJanuary 19, 1882.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Ethics of Journalism, The")]), _vm._v(". "), _c('i', [_vm._v("Pall Mall Gazette")]), _vm._v(", September\n20, 25, 1894.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Fascinating Book, A")]), _vm._v(". "), _c('i', [_vm._v("Womans World")]), _vm._v(", November, 1888.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Fisherman and his Soul, The")]), _vm._v(". In 'A House of Pomegranates.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Fragment from the Agamemnon of Æschylos, A")]), _vm._v(". "), _c('i', [_vm._v("Kottabos")]), _vm._v(",\nHilary Term, 1877.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("From Spring Days to Winter")]), _vm._v(" (for Music). "), _c('i', [_vm._v("Dublin University\nMagazine")]), _vm._v(", January, 1876.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Graffiti d'Italia")]), _vm._v(" (Arona. Lago Maggiore). "), _c('i', [_vm._v("Month and\nCatholic Review")]), _vm._v(", September, 1876.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Graffiti d'Italia")]), _vm._v(" (San Miniato). "), _c('i', [_vm._v("Dublin University\nMagazine")]), _vm._v(", March, 1876.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Grave of Keats, The")]), _vm._v(". "), _c('i', [_vm._v("Burlington")]), _vm._v(", January, 1881.")]), _vm._v(" "), _c('p', [_vm._v("'"), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Green Carnation, The")]), _vm._v(".' "), _c('i', [_vm._v("Pall Mall Gazette")]), _vm._v(", Oct. 2, 1894.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Grosvenor Gallery, The")]), _vm._v(". "), _c('i', [_vm._v("Dublin University Magazine")]), _vm._v(",\nJuly, 1877.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Guido Ferranti")]), _vm._v(" (Selection from 'The Duchess of Padua').\nWerner's "), _c('i', [_vm._v("Readings and Recitations")]), _vm._v(", New York, 1891.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Happy Prince and other Tales, The")]), _vm._v(". David Nutt,\n1888 (May), 1889 (January), 1902 (February).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Helas!")]), _vm._v(" "), _c('i', [_vm._v("Poets and Poetry of the Century")]), _vm._v(". Edited by\nA. H. Miles, Vol. viii, 1891, 1898.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Harlot's House, The")]), _vm._v(". 1885"), _c('a', {
    attrs: {
      "id": "FNanchor_2_33"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_2_33"
    }
  }, [_vm._v("[2]")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00113",
      "title": "[Pg 96]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_96",
      "title": "[Pg 96]"
    }
  })]), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Heu Miserande Puer!")]), _vm._v(" See 'Tomb of Keats, The.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("House of Judgment, The")]), _vm._v(". "), _c('i', [_vm._v("Spirit Lamp")]), _vm._v(", February 17,\n1893. In 'Poems in Prose.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("House of Pomegranates, A")]), _vm._v(". Osgood, McIlvaine & Co.,\n1891 (November).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("House of Pomegranates, A")]), _vm._v(" (Reply to Criticism of).\n"), _c('i', [_vm._v("Speaker")]), _vm._v(", December 5, 1891.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Ideal Husband, An")]), _vm._v(". Leonard Smithers & Co., 1899\n(July)")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Importance of being Earnest, The")]), _vm._v(". Leonard Smithers\n& Co., 1899 (February).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Impression de Matin")]), _vm._v(". "), _c('i', [_vm._v("World")]), _vm._v(", March 2, 1881"), _c('a', {
    attrs: {
      "id": "FNanchor_3_34"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_3_34"
    }
  }, [_vm._v("[3]")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Intentions")]), _vm._v(". Osgood, McIlvaine & Co., 1891 (May).\nNew Edition, 1894"), _c('a', {
    attrs: {
      "id": "FNanchor_4_35"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_4_35"
    }
  }, [_vm._v("[4]")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Keats' Love Letters, Sonnet on the Recent Sale by\nAuction of")]), _vm._v(". "), _c('i', [_vm._v("Dramatic Review")]), _vm._v(", January 23, 1886.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Keats' Sonnet on Blue")]), _vm._v(". "), _c('i', [_vm._v("Century Guild Hobby Horse")]), _vm._v(",\nJuly, 1886.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("La Belle Marguerite")]), _vm._v(". Ballade du Moyen Age.\n"), _c('i', [_vm._v("Kottabos")]), _vm._v(", Hilary Term, 1879.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("La Fuite de la Lune")]), _vm._v(". "), _c('i', [_vm._v("Poems and Lyrics of Nature")]), _vm._v(",\nEdited by E. W. Rinder, Walter Scott, 1894 (May 9).")]), _vm._v(" "), _c('hr', {
    staticClass: "r5"
  }), _vm._v(" "), _c('div', {
    staticClass: "figcenter",
    staticStyle: {
      "width": "440px"
    },
    attrs: {
      "aria-labelledby": "ebm_caption4",
      "role": "figure"
    }
  }, [_c('a', {
    attrs: {
      "id": "THE_WOMANS_WORLD"
    }
  }), _c('img', {
    attrs: {
      "alt": "",
      "id": "id-5751970918386443997",
      "src": "5208151284131596110_ill06.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "caption",
    attrs: {
      "id": "ebm_caption4"
    }
  }, [_vm._v("'THE WOMAN'S WORLD.'"), _c('br'), _vm._v("\nEdited by Oscar Wilde from November, 1887, to September, 1889."), _c('br'), _vm._v("\nReduced facsimile of the Cover (12 by 9¼).]"), _c('br')])]), _vm._v(" "), _c('hr', {
    staticClass: "r5"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00114",
      "title": "[Pg 97]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_97",
      "title": "[Pg 97]"
    }
  })]), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Lady Alroy")]), _vm._v(". "), _c('i', [_vm._v("World")]), _vm._v(", May 25, 1887. In 'Lord Arthur\nSavile's Crime and other Stories.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Lady Windermere's Fan")]), _vm._v(". Elkin Mathews & John\nLane, 1893 (November 8).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Le Jardin des Tuileries")]), _vm._v(". "), _c('i', [_vm._v("In a Good Cause")]), _vm._v(", Wells\nGardner, Darton & Co., 1885 (June).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("L'Envoi")]), _vm._v(". "), _c('i', [_vm._v("Rose Leaf and Apple Leaf")]), _vm._v(", by Rennell Rodd.\nJ. M. Stoddart & Co., Philadelphia, 1882.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Le Reveillon")]), _vm._v(". "), _c('i', [_vm._v("Poems and Lyrics of Nature")]), _vm._v(". Edited by\nE. W. Rinder. Walter Scott, 1894 (May 9).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Les Silhouettes")]), _vm._v(". "), _c('i', [_vm._v("Poems and Lyrics of Nature")]), _vm._v(". Edited\nby E. W. Rinder. Walter Scott, 1894 (May 9).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Libel Action against Lord Queensberry, The")]), _vm._v(".\n"), _c('i', [_vm._v("Evening News")]), _vm._v(", April 5, 1895.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Libertatis Sacra Fames")]), _vm._v(". "), _c('i', [_vm._v("World")]), _vm._v(", November 10, 1880"), _c('a', {
    attrs: {
      "id": "FNanchor_5_36"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_5_36"
    }
  }, [_vm._v("[5]")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Literary and other Notes")]), _vm._v(". "), _c('i', [_vm._v("Woman's World")]), _vm._v(",\nNovember, December, 1887; January to March, 1888.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("London Models")]), _vm._v(". Illustrations by Harper Pennington.\n"), _c('i', [_vm._v("English Illustrated Magazine")]), _vm._v(", January, 1889.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Lord Arthur Savile's Crime")]), _vm._v(". A story of Cheiromancy.\nIllustrations by F. H. Townsend. "), _c('i', [_vm._v("Court and Society\nReview")]), _vm._v(", May 11, 18, 25, 1887. In 'Lord Arthur\nSavile's Crime and Other Stories.'")]), _vm._v(" "), _c('p', [_c('i', [_vm._v("Lord Arthur Savile's Crime and other Stories")]), _vm._v(".\nOsgood, McIlvaine & Co., 1891 (July).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Lotus Leaves")]), _vm._v(". "), _c('i', [_vm._v("Irish Monthly")]), _vm._v(", February, 1877.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Magdalen Walks")]), _vm._v(". "), _c('i', [_vm._v("Irish Monthly")]), _vm._v(", April, 1878.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00115",
      "title": "[Pg 98]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_98",
      "title": "[Pg 98]"
    }
  })]), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Master, The")]), _vm._v(". In 'Poems and Prose.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Model Millionaire, The")]), _vm._v(". "), _c('i', [_vm._v("World")]), _vm._v(", June 22, 1887. In\n'Lord Arthur Savile's Crime and other Stories.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("More Radical Ideas on Dress Reform")]), _vm._v(". "), _c('i', [_vm._v("Pall Mall\nGazette")]), _vm._v(", November 11, 1884.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Mr. Pater's Last Volume")]), _vm._v(". "), _c('i', [_vm._v("Speaker")]), _vm._v(", March 22, 1890.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Mr. Whistler's Ten O'Clock")]), _vm._v(". "), _c('i', [_vm._v("Pall Mall Gazette")]), _vm._v(",\nFebruary 21, 1885.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("New Helen, The")]), _vm._v(". "), _c('i', [_vm._v("Time")]), _vm._v(", July, 1879.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("New Remorse, The")]), _vm._v(". "), _c('i', [_vm._v("Spirit Lamp")]), _vm._v(", December 6, 1892.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Night Vision, A")]), _vm._v(". "), _c('i', [_vm._v("Kottabos")]), _vm._v(", Hilary Term, 1877.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Nightingale and the Rose, The")]), _vm._v(". "), _c('i', [_vm._v("La Plume")]), _vm._v(", December\n15, 1900. In 'The Happy Prince and Other\nTales.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Note on Some Modern Poets, A")]), _vm._v(". "), _c('i', [_vm._v("Woman's World")]), _vm._v(",\nDecember, 1888.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Oh! Beautiful Star")]), _vm._v(". (Three verses of 'Under the\nBalcony'). Set to music by Lawrence Kellie.\nRobert Cocks & Co., 1892.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("On Criticism; with some Remarks on the Importance\nof doing Nothing")]), _vm._v(". "), _c('i', [_vm._v("Nineteenth Century")]), _vm._v(", July,\nSeptember, 1890. In 'Intentions.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Pen, Pencil, and Poison: A Study")]), _vm._v(". "), _c('i', [_vm._v("Fortnightly\nReview")]), _vm._v(", January, 1889. In 'Intentions.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Phrases and Philosophies for the Use of the\nYoung")]), _vm._v(". "), _c('i', [_vm._v("Chameleon")]), _vm._v(", 1894 (December).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Phêdre")]), _vm._v(". See 'To Sarah Bernhardt.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Picture of Dorian Gray, The")]), _vm._v(" (13 Chapters)."), _c('i', [_vm._v(" Lippincott's\nMonthly Magazine")]), _vm._v(", July, 1890.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00116",
      "title": "[Pg 99]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_99",
      "title": "[Pg 99]"
    }
  })]), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Picture of Dorian Gray, The")]), _vm._v(" (20 Chapters). Ward,\nLock & Co., 1891 (July 1). New Edition, 1894\n(October 1).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Picture of Dorian Gray, The")]), _vm._v(". (Replies to Criticism\nof). "), _c('i', [_vm._v("Daily Chronicle")]), _vm._v(", July 2, 1890. "), _c('i', [_vm._v("Scots Observer")]), _vm._v(",\nJuly 12, August 2, 16, 1890.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Poems")]), _vm._v(". David Bogue, 1881 (July). 5th Edition, 1882.\nElkin Mathews & John Lane, 1892 (May 26).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Poems in Prose")]), _vm._v(". "), _c('i', [_vm._v("Fortnightly Review")]), _vm._v(", July, 1894.")]), _vm._v(" "), _c('p', [_vm._v("Πόντος Ἀτρύγετος. "), _c('i', [_vm._v("Irish Monthly")]), _vm._v(", December, 1877.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Portia")]), _vm._v(". "), _c('i', [_vm._v("World")]), _vm._v(", January 14, 1880.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Portrait of Mr. W. H., The")]), _vm._v(". "), _c('i', [_vm._v("Blackwood's Edinburgh\nMagazine")]), _vm._v(", July, 1889"), _c('a', {
    attrs: {
      "id": "FNanchor_6_37"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_6_37"
    }
  }, [_vm._v("[6]")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Preface to 'Dorian Gray,' A")]), _vm._v(". "), _c('i', [_vm._v("Fortnightly Review")]), _vm._v(",\nMarch, 1891.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Puppets and Actors")]), _vm._v(". "), _c('i', [_vm._v("Daily Telegraph")]), _vm._v(", February?,\n1892"), _c('a', {
    attrs: {
      "id": "FNanchor_7_38"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_7_38"
    }
  }, [_vm._v("[7]")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Queen Henrietta Maria")]), _vm._v(" ("), _c('i', [_vm._v("Charles I., act iii.")]), _vm._v("). "), _c('i', [_vm._v("World")]), _vm._v(",\nJuly 16, 1879.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Ravenna")]), _vm._v(". T. Shrimpton & Son, Oxford, 1878 (June).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00117",
      "title": "[Pg 100]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_100",
      "title": "[Pg 100]"
    }
  })]), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Remarkable Rocket, The")]), _vm._v(". In 'The Happy Prince and\nOther Tales.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Requiescat")]), _vm._v(". "), _c('i', [_vm._v("Dublin Verses")]), _vm._v(", by Members of Trinity\nCollege. Elkin Mathews, 1895.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Rise of Historical Criticism, The")]), _vm._v(". Privately printed.\nAmerica, 1905"), _c('a', {
    attrs: {
      "id": "FNanchor_8_39"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_8_39"
    }
  }, [_vm._v("[8]")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Rose of Love and with a Rose's Thorns")]), _vm._v(". See\nΔηξίθυμον Ἔρωτος Ἄνθος.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Roses and Rue")]), _vm._v(". "), _c('i', [_vm._v("Midsummer Dreams")]), _vm._v(", Summer Number\nof "), _c('i', [_vm._v("Society")]), _vm._v(", July, 1885.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Salomé")]), _vm._v(" (French Edition.) Librairie de l'Art Indépendant,\nParis, 1893 (February 22).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Salome")]), _vm._v(" (English Edition). Elkin Mathews & John\nLane, 1894 (February 9).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Salve Saturnia Tellus")]), _vm._v(". "), _c('i', [_vm._v("Irish Monthly")]), _vm._v(", June, 1877.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Selfish Giant, The")]), _vm._v(". In 'The Happy Prince and Other\nTales.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Sen Artysty; or, the Artist's Dream")]), _vm._v(". See 'Artist's\nDream, The.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Shakespeare and Stage Costume")]), _vm._v(". "), _c('i', [_vm._v("Nineteenth Century")]), _vm._v(",\nMay, 1885. In 'Intentions.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Some Cruelties of Prison Life")]), _vm._v(". See 'Case of Warder\nMartin, The,' and 'Children in Prison.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Some Literary Notes")]), _vm._v(". "), _c('i', [_vm._v("Woman's World")]), _vm._v(", January to\nJune, 1889.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Relation of Dress to Art, The")]), _vm._v(". "), _c('i', [_vm._v("Pall Mall Gazette")]), _vm._v(",\nFebruary 28, 1885.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00118",
      "title": "[Pg 101]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_101",
      "title": "[Pg 101]"
    }
  })]), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Soul of Man under Socialism, The")]), _vm._v(". "), _c('i', [_vm._v("Fortnightly\nReview")]), _vm._v(", February, 1891"), _c('a', {
    attrs: {
      "id": "FNanchor_9_40"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_9_40"
    }
  }, [_vm._v("[9]")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Sphinx, The")]), _vm._v(". Elkin Mathews & John Lane, 1894\n(September 29).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Sphinx without a Secret, The")]), _vm._v(". See 'Lady Alroy.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Star-Child, The")]), _vm._v(". In 'A House of Pomegranates.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Teacher of Wisdom, The")]), _vm._v(". In 'Poems in Prose.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Theocritus")]), _vm._v(". "), _c('i', [_vm._v("Ballades and Rondeaus")]), _vm._v(". Selected by\nGleeson White. Walter Scott Publishing Co., 1889\n(June 30)"), _c('a', {
    attrs: {
      "id": "FNanchor_10_41"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_10_41"
    }
  }, [_vm._v("[10]")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("Θρηνῳδία. "), _c('i', [_vm._v("Kottabos")]), _vm._v(", Michaelmas Term, 1876.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("To Milton")]), _vm._v(". "), _c('i', [_vm._v("Poets and Poetry of the Century")]), _vm._v(", Edited by\nA. H. Miles, Vol. viii, 1891, 1898.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("To My Wife: with a Copy of My Poems")]), _vm._v(". "), _c('i', [_vm._v("Book-Song")]), _vm._v(",\nElliot Stock, 1893.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("To Sarah Bernhardt")]), _vm._v(". "), _c('i', [_vm._v("World")]), _vm._v(", June 11, 1879.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Tomb of Keats, The")]), _vm._v(". "), _c('i', [_vm._v("Irish Monthly")]), _vm._v(", July, 1877.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("True Function and Value of Criticism, The")]), _vm._v(". See\n'Critic as Artist, The,' and 'On Criticism.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00119",
      "title": "[Pg 102]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_102",
      "title": "[Pg 102]"
    }
  })]), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("True Knowledge, The")]), _vm._v(". "), _c('i', [_vm._v("Irish Monthly")]), _vm._v(", September,\n1876"), _c('a', {
    attrs: {
      "id": "FNanchor_11_42"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_11_42"
    }
  }, [_vm._v("[11]")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Truth of Masks, The")]), _vm._v(". See 'Shakespeare and Stage\nCostume.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Under the Balcony")]), _vm._v(". "), _c('i', [_vm._v("Shaksperean Show-Book")]), _vm._v(" (May\n29, 1884). See 'Oh! Beautiful Star!'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Un Amant de nos Jours")]), _vm._v(". "), _c('i', [_vm._v("Court and Society Review")]), _vm._v(",\nDecember 13, 1887. See 'New Remorse, The.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Vera, or the Nihilists")]), _vm._v(". Privately printed for the\nAuthor; America, 1882.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Vita Nuova")]), _vm._v(". See Πόντος Ἀτρύγετος.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Wasted Days")]), _vm._v(" (From a Picture Painted by Miss V. T.).\n"), _c('i', [_vm._v("Kottabos")]), _vm._v(", Michaelmas Term, 1877.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Whistler, Correspondence with")]), _vm._v(". "), _c('i', [_vm._v("World")]), _vm._v(", November\n14, 1883; February 25, 1885; November 24, 1886.\n"), _c('i', [_vm._v("Truth")]), _vm._v(", January 9, 1890.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Whistler's Lectures Reviewed")]), _vm._v(". See 'Mr. Whistler's\nTen O'Clock 'and 'Relation of Dress to Art, The.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("With a Copy of 'A House of Pomegranates.'")]), _vm._v(" "), _c('i', [_vm._v("Book-Song")]), _vm._v(",\nElliot Stock, 1893.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Woman of no Importance, A")]), _vm._v(". John Lane, The Bodley\nHead, 1894 (October 9).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Woman's World, The")]), _vm._v(". Edited by Oscar Wilde,\n1887–9. Cassell & Co.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Young King, The")]), _vm._v(". Illustrations by Bernard Partridge.\n"), _c('i', [_vm._v("Lady's Pictorial")]), _vm._v(", Christmas Number, 1888. In 'A\nHouse of Pomegranates.'")]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_1_32"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_1_32"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[1]")])]), _vm._v(" The title-page reads:—The Duchess of Padua A Tragedy\nof the XVI Century by Oscar Wilde Author of \"Vera,\" etc.\nWritten in Paris in the XIX Century. Privately printed as\nManuscript. March 15, 1883 "), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("a. d.")])]), _vm._v(" "), _c('p', [_vm._v("\nThe cover is inscribed 'Op. II.' Twenty copies were\nprinted, of which one only is known to exist in England, the\nproperty of Mr. Robert Ross. It is in grey paper wrappers,\n8vo., pp. 122. The play was acted in America in 1883 by the\nlate Lawrence Barrett, shortly before his death. It is sometimes\nknown as "), _c('i', [_vm._v("Guido Ferranti")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_2_33"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_2_33"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[2]")])]), _vm._v(" The original publication of 'The Harlot's House' has not\nyet been traced. The approximate date is known by a parody\non the poem, called 'The Public House, 'which appeared in\n"), _c('i', [_vm._v("The Sporting Times")]), _vm._v(" of June 13, 1885. In 1904 a privately\nprinted edition, on folio paper, with five illustrations by\nAlthea Gyles, was issued by 'The Mathurin Press,' London.\nIn 1905 another edition was privately printed in London,\npp. 8, wrappers.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_3_34"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_3_34"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[3]")])]), _vm._v(" See "), _c('i', [_vm._v("Notes and Queries")]), _vm._v(", Series ix., vol. xii., page 85.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_4_35"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_4_35"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[4]")])]), _vm._v(" Continental Edition issued by Messrs. Heinemann and\nBalestier in 'The English Library,' No. 54. 1891.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_5_36"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_5_36"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[5]")])]), _vm._v(" See "), _c('i', [_vm._v("Sonnets of this Century")]), _vm._v(". Edited by William Sharp.\nWalter Scott Publishing Co., 1888 (March 22).")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_6_37"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_6_37"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[6]")])]), _vm._v(" Early in 1894, Messrs. Elkin Mathews and John Lane\nannounced as being in preparation, 'The incomparable and\ningenious history of Mr. W. H., being the true secret of\nShakespear's sonnets, now for the first time here fully set\nforth. With initial letters and cover design by Charles\nRicketts.' On the evening of his arrest, April 5, 1895, the\npublishers returned the MS. to Mr. Wilde's house, and it is\nsaid to have been stolen from there a few hours later.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_7_38"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_7_38"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[7]")])]), _vm._v(" See "), _c('i', [_vm._v("Saturday Review")]), _vm._v(", July 2, 1892.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_8_39"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_8_39"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[8]")])]), _vm._v(" The authenticity of this work is not vouched for.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_9_40"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_9_40"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[9]")])]), _vm._v(" It was the author's wish that 'The Soul of Man under\nSocialism' should be known as 'The Soul of Man,' and by\nthis title he himself refers to it in "), _c('i', [_vm._v("De Profundis")]), _vm._v(". A privately\nprinted edition was published by Mr. Arthur L. Humphreys\nunder this title in 1895, and again in 1904 in 'Sebastian Melmoth.'\nIt appeared also in "), _c('i', [_vm._v("Wilshire's Magazine")]), _vm._v(", Toronto, Canada,\nfor June, 1902; and, under its original title, in a pirated edition\nissued in London, 1904; and in a beautiful edition published\nby Mr. Thos. B. Mosher, of Portland, Maine, U.S.A., April,\n1905.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_10_41"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_10_41"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[10]")])]), _vm._v(" See "), _c('i', [_vm._v("Literature")]), _vm._v(", December 8, 1900.")])]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_11_42"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_11_42"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[11]")])]), _vm._v(" Re-printed in "), _c('i', [_vm._v("Dublin Verses")]), _vm._v(", 1895; and "), _c('i', [_vm._v("The Tablet")]), _vm._v(", December\n8, 1900.")])]), _vm._v(" "), _c('hr', {
    staticClass: "chap"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00120",
      "title": "[Pg 103]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_103",
      "title": "[Pg 103]"
    }
  })])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "pgepubid00121"
    }
  }, [_vm._v("NOTE.")]), _vm._v(" "), _c('p', [_vm._v("In the foregoing list the following particulars are\ngiven:—")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Titles of books with name of publisher and date\nof publication of each edition.")]), _vm._v(" "), _c('li', [_vm._v("Contributions to magazines and periodicals\nwhether re-printed in book-form later or not.")]), _vm._v(" "), _c('li', [_vm._v("Poems which have been re-printed in collections\nof verse of later date than Bogue's edition of the\n'Poems,' 1881. These will be found under their\nrespective titles, but when a poem has been\nincluded in more than one such collection the\nreference is given, as a rule, to the book of\nearliest date.")])]), _vm._v(" "), _c('p', [_vm._v("The publications of Messrs. Elkin Mathews and John\nLane, and of Mr. John Lane, were issued simultaneously\nin America by Messrs. Copeland and Day, of Boston.\n"), _c('i', [_vm._v("De Profundis")]), _vm._v(" was published in America by Messrs. G. P.\nPutnam's Sons, of New York. Seven editions have been\nissued. "), _c('i', [_vm._v("The Decay of Lying, The Portrait of Mr. W. H.")]), _vm._v(",\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00122",
      "title": "[Pg 104]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_104",
      "title": "[Pg 104]"
    }
  })]), _vm._v("and "), _c('i', [_vm._v("The Soul of Man under Socialism")]), _vm._v(", appeared in the\n'Eclectic Magazine' of New York a few weeks after\npublication in this country.")]), _vm._v(" "), _c('p', [_vm._v("No notice is taken in this Bibliography of many unauthorised\nand pirated reprints, and those works which\nhave been falsely attributed to Mr. Wilde by unscrupulous\npublishers are all rejected. Of the latter 'The Priest\nand the Acolyte,' and translations of 'Ce Qui ne Meurt\npas' and the 'Satyricon' of Petronius are examples.")]), _vm._v(" "), _c('hr', {
    staticClass: "chap"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00123",
      "title": "[Pg 105]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_105",
      "title": "[Pg 105]"
    }
  })])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "pgepubid00124"
    }
  }, [_c('i', [_vm._v("Books containing Selections from the\nWorks of Oscar Wilde.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Best of Oscar Wilde, The")]), _vm._v(". (Collection of Poems and\nProse Extracts). Collected by C. Herrmann. Brentano,\nNew York, 1905 (March).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Epigrams and Aphorisms")]), _vm._v(". Edited by G. H. Sargent.\nJohn W. Luce & Co., Boston, U.S.A., 1905 (July).")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Essays, Criticisms and Reviews")]), _vm._v(". Now first collected.\n(From "), _c('i', [_vm._v("The Woman's World")]), _vm._v("). Privately printed.\nLondon, 1901.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Oscariana. Epigrams")]), _vm._v(". Arthur Humphreys, 1895"), _c('a', {
    attrs: {
      "id": "FNanchor_1_43"
    }
  }), _c('a', {
    staticClass: "fnanchor pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#Footnote_1_43"
    }
  }, [_vm._v("[1]")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Sebastian Melmoth")]), _vm._v(" (Selection from Prose Writings; and\n'The Soul of Man'). Arthur L. Humphreys, 1904\n(September).")]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "Footnote_1_43"
    }
  }), _c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/3677167308067835197_53226h0.htm#FNanchor_1_43"
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("[1]")])]), _vm._v(" Only one copy bore the publisher's name. The rest were\nissued as 'privately printed.' The edition consisted of 25\ncopies only, but forged reprints are numerous. The selection\nof epigrams is said to have been made by Mrs. Wilde.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00125",
      "title": "[Pg 106]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_106",
      "title": "[Pg 106]"
    }
  })])]), _vm._v(" "), _c('hr', {
    staticClass: "chap"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00126",
      "title": "[Pg 107]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_107",
      "title": "[Pg 107]"
    }
  })])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "pgepubid00127"
    }
  }, [_c('i', [_vm._v("Bibliographical Notes on the English\nEditions.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("A House of Pomegranates.")])]), _vm._v(" "), _c('p', [_vm._v("The following is the author's own description of 'the\ndecorative designs that make lovely' this book of 'beautiful\ntales,' and of 'the delicate dreams that separate and herald\neach story':—")]), _vm._v(" "), _c('p', [_vm._v("'Mr. Shannon is the drawer of the dreams, and Mr.\nRicketts is the subtle and fantastic decorator. Indeed, it is\nto Mr. Ricketts that the entire decorative design of the book\nis due, from the selection of the type and the placing of the\nornamentation, to the completely beautiful cover that encloses\nthe whole.... The artistic beauty of the cover resides in the\ndelicate tracing, arabesques, and massing of many coral-red\nlines on a ground of white ivory, the colour effect culminating\nin certain high gilt notes, and being made still more pleasurable\nby the overlapping band of moss-green cloth that holds\nthe book together.'")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Ballad of Reading Gaol.")])]), _vm._v(" "), _c('p', [_vm._v("1st edition, 8vo, pp. 31, 800 copies on hand-made paper,\nand 30 on Japan vellum, February, 1898. Before the 2nd\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00128",
      "title": "[Pg 108]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_108",
      "title": "[Pg 108]"
    }
  })]), _vm._v("edition was published, in March, the author made several\nalterations in the text. The 3rd edition was 99 copies only,\neach signed by the author; bound in purple cloth sides, 4to.\nEditions 4, 5, and 6 (1898) are similar to the 2nd edition and\nthe number of each edition is printed on the back of title-page.\nThe 7th edition (1899) bears the author's name on the title-page.\nIt is the last of Smithers' editions on hand-made paper.\nAll his subsequent editions are printed in a new type from\nstereotyped plates, on thick wove paper, and bear no number\nto distinguish the edition. They are all dated 1899.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("De Profundis.")])]), _vm._v(" "), _c('p', [_vm._v("Of the 1st edition 200 copies were printed on hand-made\npaper at 21/- and 50 on Japan vellum at 42/-. Of the ordinary\n5/- edition four impressions were issued within a month of\npublication.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Happy Prince and Other Tales.")])]), _vm._v(" "), _c('p', [_vm._v("Of the 1st edition 75 copies (65 for sale) were printed on\nlarge paper with the plates in two states. Of the small paper\ncopies the 1st edition was published at 5/-, the 2nd and 3rd at\n3/6 each.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("An Ideal Husband and The Importance of\nBeing Earnest.")])]), _vm._v(" "), _c('p', [_vm._v("Each edition consists of 1000 copies, 7/6 net, and 100 on\nlarge paper, 21/- net. Twelve copies of each, signed by the\nauthor, were issued on Japan vellum. Of this edition No. 4\nof each play is in the British Museum.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00129",
      "title": "[Pg 109]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_109",
      "title": "[Pg 109]"
    }
  })]), _c('span', {
    staticClass: "smcap"
  }, [_vm._v("Intentions.")])]), _vm._v(" "), _c('p', [_vm._v("1st edition, 1891, 7/6; new edition, 1894, 3/6.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Lady Windermere's Fan and A Woman of No\nImportance.")])]), _vm._v(" "), _c('p', [_vm._v("With a specially designed binding to each volume by\nCharles Shannon. 500 copies, sm. 4to, 7/6 net, and 50 copies\nlarge paper, 15/- net.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Picture of Dorian Gray.")])]), _vm._v(" "), _c('p', [_vm._v("Of the 1st edition 250 copies on hand-made paper, signed\nby the author, were issued at 21/-, dated 1891. The small\npaper editions are not dated. The 2nd (1894) can be distinguished\nfrom the 1st (1891) by the publisher's name, Ward,\nLock and Bowden, Limited, on the title-page. The published\nprice of each was 6/-.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Poems.")])]), _vm._v(" "), _c('p', [_vm._v("Bogue's 1st, 2nd and 3rd editions are dated 1881, pp. 236.\nThe 4th and 5th editions (1882) have several alterations made\nby the author in the text, and contain 234 pages only. The\nedition published by Elkin Mathews and John Lane in 1892\nconsisted of 220 copies (200 for sale), on hand-made paper,\nwith cover design by Charles Ricketts, price 15/-. The text is\na reprint of Bogue's 1882 editions.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Ravenna.")])]), _vm._v(" "), _c('p', [_vm._v("Forged imitations of Messrs. Shrimpton and Son's edition\nare common. They can be distinguished from the originals by\n"), _c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00130",
      "title": "[Pg 110]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_110",
      "title": "[Pg 110]"
    }
  })]), _vm._v("the omission of the Arras of Oxford University on cover and\ntitle-page.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Salomé.")])]), _vm._v(" "), _c('p', [_vm._v("The edition in French, limited to 600 copies (500 for sale),\nprinted in Paris, was published by the Librairie de l'Art\nIndépendant, Paris, and Messrs. Matthews and Lane, London;\npp. 84, purple wrappers lettered in silver, 5/- net. The English\nedition was translated by Lord Alfred Douglas and pictured by\nAubrey Beardsley with 10 illustrations, title-page, tail-piece,\nand cover design. 500 copies, small 4to, 15/- net; 100 copies\nlarge paper, 30/- net.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Sphinx.")])]), _vm._v(" "), _c('p', [_vm._v("Decorated throughout in line and colour and bound in\na design by Charles Ricketts. 250 copies at £2/2/- net, and\n25 on large paper at £5/5/- net.")]), _vm._v(" "), _c('hr', {
    staticClass: "r5"
  }), _vm._v(" "), _c('p', [_vm._v("Translations of many of Oscar Wilde's works have\nappeared in French, German, Polish, Hungarian, Spanish,\nItalian, Russian, and other foreign languages. Full particulars\nof all editions will be included in 'A Bibliography\nof Oscar Wilde' by Walter Ledger and Stuart Mason,\nnow in preparation.")]), _vm._v(" "), _c('hr', {
    staticClass: "chap"
  }), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "x-ebookmaker-pageno",
    attrs: {
      "id": "pgepubid00131",
      "title": "[Pg 111]"
    }
  }, [_c('a', {
    attrs: {
      "id": "Page_111",
      "title": "[Pg 111]"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("IN PREPARATION.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Sonnets of Oscar Wilde")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Now First Collected.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("EDITED, WITH NOTES, BY")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("STUART MASON.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Views and Reviews")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The Uncollected Prose Writings and")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Letters of Oscar Wilde.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("EDITED BY")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("STUART MASON.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("The")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Bibliography of Oscar Wilde")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("BY")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Walter Ledger and Stuart Mason.")]), _vm._v(" "), _c('hr', {
    staticClass: "r5"
  }), _vm._v(" "), _c('pre')])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bb86662","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/3677167308067835197_53226-h-0.htm.vue
// module id = 54
// module chunks = 0